// Source snapshot: Epoch AI Data Centers, retrieved 2026-08-09.
export const epochDataCenterProjects = {
  "asOf": "2026-08-09",
  "projects": [
    {
      "name": "Colossus 2",
      "slug": "colossus-2",
      "owner": "SpaceXAI",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "confident"
        },
        {
          "name": "Cursor",
          "confidence": "confident"
        },
        {
          "name": "SpaceXAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "5420 Tulane Rd, Memphis, TN 38109",
      "project": "",
      "currentChipTypes": [
        "B200",
        "B300"
      ],
      "allChipTypes": [
        "B200",
        "B300"
      ],
      "currentPowerMw": 946.0,
      "currentH100Equivalent": 1111672.5618999496,
      "currentCapitalCostB": 35.836372,
      "timeline": [
        {
          "date": "2025-02-28",
          "status": "Land clearing begins next to the existing building.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-08",
          "status": "Battery facility connected to the building. 121 air-cooled chillers installed, which could support 200 MW. In the Duke faciltiy in nearby Mississippi, several natural gas turbines are in place but not fully connected up.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-19",
          "status": "Battery facility looks complete (though more might be added). Turbines look connected up, minimal construction around them. We believe this state corresponds to the first compute cluster brought online at this site of \"approximately 110,000 GB200 processors, approximately 210 megawatts of compute power\", as detailed in the [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm). Based on those numbers, we believe \"compute power\" corresponds to GPU server power. [Earlier](https://x.com/elonmusk/status/1947715674429919279) [tweets](https://x.com/elonmusk/status/1950251710141567110) from Elon Musk also support this timing, and it's consistent with the estimated cooling capacity based on the satellite image.",
          "buildingsOperational": 1.0,
          "itPowerMw": 239.0,
          "h100Equivalent": 277918.1404749874,
          "capitalCostB": 9.053798
        },
        {
          "date": "2026-01-13",
          "status": "Since October, an array of dry cooling air-cooled condensers has been added (the array of large fans to the left of the building), and appears almost complete. Two more similar arrays appear to be under construction. More air-cooled chillers, batteries, and gas turbines have also been installed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 239.0,
          "h100Equivalent": 277918.1404749874,
          "capitalCostB": 9.053798
        },
        {
          "date": "2026-04-06",
          "status": "The first array of dry cooling air-cooled condensers for Building 1 has been completed and is operational. A second array, with larger fans, is about halfway complete (located to the south of the first array). More chillers have also been added. For Building 2, an array of dry cooling air-cooled condensers of the same type as Building 1's first array is beginning construction. We believe this corresponds to the \"second cluster of 110,000 GB300 processors and 220 megawatts of compute power\" from the [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm), with compute power corresponding to GPU server power. This is also consistent with our estimates based on cooling equipment.",
          "buildingsOperational": 1.0,
          "itPowerMw": 490.0,
          "h100Equivalent": 555836.2809499748,
          "capitalCostB": 18.562179999999998
        },
        {
          "date": "2026-06-15",
          "status": "The site is estimated to have at least ~830 MW of GPU server power, with at least \"at least 220,000 additional GB300 processors and over 400 additional megawatts of compute power\", corresponding to the \"next phase of expansion\" found in the following [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm).This estimate is backed up by our cooling and turbine based power production calculations. The cooling calculations suggest there is enough infrastructure to support ~850MW of IT Power. Similarly the energy production calculations support ~900MW of available IT Power. This gives us confidence that the proposed expansion was achieved in time. The roof for building 3 is halfway complete.",
          "buildingsOperational": 2.0,
          "itPowerMw": 946.0,
          "h100Equivalent": 1111672.5618999496,
          "capitalCostB": 35.836372
        },
        {
          "date": "2027-02-25",
          "status": "Building 3 is estimated to be completed. The site is predicted to have enough power infrastructure installed for a total of 1.5 GW of IT Power. Based on building plans we predict the addition of three more cooling arrays similar to the 6x24 dry coolers near Building 1 and 2. With the completion of current cooling structures and the addition of these arrays there will be ~540MW more cooling capacity for a full facility total of ~1390MW. If this cooling capacity is supplemented by mobile coolers, there would be enough cooling and power infrastructure to support 1.5 GW of IT power.",
          "buildingsOperational": 3.0,
          "itPowerMw": 1531.0,
          "h100Equivalent": 1824153.6129358262,
          "capitalCostB": 57.997341999999996
        }
      ]
    },
    {
      "name": "Microsoft Fairwater Atlanta",
      "slug": "microsoft-fairwater-atlanta",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "likely"
        },
        {
          "name": "Microsoft",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "1435 Hwy 54 W, Fayetteville, GA 30214",
      "project": "Microsoft AI WAN #confident",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 636.0,
      "currentH100Equivalent": 768768.7220818596,
      "currentCapitalCostB": 24.092952,
      "timeline": [
        {
          "date": "2023-04-09",
          "status": "Land clearing begins for southern part (Building 1-2)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-14",
          "status": "Building 1 and 2 are [operational](https://news.microsoft.com/source/features/ai/from-wisconsin-to-atlanta-microsoft-connects-datacenters-to-build-its-first-ai-superfactory/). Building 1 looked operational sooner, but the buildings [are paired](https://blogs.microsoft.com/blog/2025/09/18/inside-the-worlds-most-powerful-ai-datacenter/) in the Fairwater design. The roof of Building 4 is almost complete, while mechanical equipment is still being installed.",
          "buildingsOperational": 2.0,
          "itPowerMw": 321.0,
          "h100Equivalent": 387981.94436584134,
          "capitalCostB": 12.160122
        },
        {
          "date": "2026-02-13",
          "status": "Building 4 roof is complete and all mechanical equipment appears to be installed. However, there is still a lot of construction activity around the building.",
          "buildingsOperational": 2.0,
          "itPowerMw": 321.0,
          "h100Equivalent": 387981.94436584134,
          "capitalCostB": 12.160122
        },
        {
          "date": "2026-05-15",
          "status": "Building 4 still has some equipment strewn around the perimeter, so we think it is still going through commissioning. Two new buildings at the campus have shells underway, but we don't know if Microsoft is the tenant for those.",
          "buildingsOperational": 2.0,
          "itPowerMw": 321.0,
          "h100Equivalent": 387981.94436584134,
          "capitalCostB": 12.160122
        },
        {
          "date": "2026-06-14",
          "status": "Building 3 and 4 are operational.",
          "buildingsOperational": 4.0,
          "itPowerMw": 636.0,
          "h100Equivalent": 768768.7220818596,
          "capitalCostB": 24.092952
        }
      ]
    },
    {
      "name": "Meta Prometheus",
      "slug": "meta-prometheus",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "1 Community Cir, New Albany, OH 43054",
      "project": "Prometheus #confident",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 631.0,
      "currentH100Equivalent": 763011.622031329,
      "currentCapitalCostB": 23.903541999999998,
      "timeline": [
        {
          "date": "2022-04-14",
          "status": "Land clearing begins for Building 1-2",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-01",
          "status": "Roof complete on Building 5 (QTS-owned). In the northernmost area, land clearing begins on a new Meta site for Buildings 15-19. Building 1 still has construction work around the building and cooling equipment, so it's unlikely to be operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-20",
          "status": "Building 4 operational. Based on our default estimate of roof-to-operational time.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-14",
          "status": "Building 1 is operational, based on there being minimal construction work and cars in the main carpark. Building 2 still has some construction work around the building. Building 15 roof is complete. The on-site power at Socrates South and Socrates North has some outlines of gas turbines, to be installed later.",
          "buildingsOperational": 1.0,
          "itPowerMw": 76.0,
          "h100Equivalent": 91965.63921172309,
          "capitalCostB": 2.879032
        },
        {
          "date": "2026-01-18",
          "status": "Buildings 2-6 are operational, based on all equipment being in place, the paved ground, and minimal construction equipment by the buildings. Buildings 7-11 all have some kind of power or cooling equipment lining their right side which are not fully installed. Building 13 has chillers installed. Buildings 15-19 roofs are complete. The Socrates South power plant to the right of Buildings 7-11 has 7 gas turbines in place, judging by the exhaust stacks.",
          "buildingsOperational": 6.0,
          "itPowerMw": 339.0,
          "h100Equivalent": 410308.2364830723,
          "capitalCostB": 12.841998
        },
        {
          "date": "2026-02-27",
          "status": "Building 12 is [operational](https://vantage-dc.com/data-center-locations/north-america/new-albany-ohio)",
          "buildingsOperational": 7.0,
          "itPowerMw": 408.0,
          "h100Equivalent": 493683.67862556846,
          "capitalCostB": 15.455855999999997
        },
        {
          "date": "2026-03-12",
          "status": "The Socrates South power plant to the right of Buildings 7-11 now has 10 natural gas turbines in place, judging by the number of exhaust stacks. Battery backup has been installed nearby. To the north, a new section of tent buildings has begun east of Buildings 15-19. It is unclear how those buildings will be powered, if we assume that the Socrates North power plant is just powering Buildings 15-19.",
          "buildingsOperational": 7.0,
          "itPowerMw": 408.0,
          "h100Equivalent": 493683.67862556846,
          "capitalCostB": 15.455855999999997
        },
        {
          "date": "2026-05-18",
          "status": "Building 7-11 (Meta tents) are operational. In January we saw them look almost complete, with some work still ongoing for power equipment. Assuming 3 more months for commissioning, we expect operation by May.",
          "buildingsOperational": 12.0,
          "itPowerMw": 562.0,
          "h100Equivalent": 677109.6513390602,
          "capitalCostB": 21.289684
        },
        {
          "date": "2026-05-28",
          "status": "Building 13 (Vantage) is operational, based on it starting construction about 3 months after Building 12.",
          "buildingsOperational": 13.0,
          "itPowerMw": 631.0,
          "h100Equivalent": 763011.622031329,
          "capitalCostB": 23.903541999999998
        },
        {
          "date": "2026-08-26",
          "status": "Building 14 (Vantage) operational, based on it starting construction about 3 months after Building 13.",
          "buildingsOperational": 14.0,
          "itPowerMw": 700.0,
          "h100Equivalent": 843860.5356240525,
          "capitalCostB": 26.5174
        },
        {
          "date": "2026-10-01",
          "status": "Socrates South and Socrates North gas power plants are operational, coinciding with Building 15-19 being operational. Based [on](https://dis.puc.state.oh.us/CaseRecord.aspx?CaseNo=25-0188-EL-BGN) [documents](https://dis.puc.state.oh.us/ViewImage.aspx?CMID=A1001001A25E29B42006E01696) [stating](https://www.williams.com/wp-content/uploads/sites/8/2025/03/Socrates-North-Fact-Sheet-Final-1.pdf) \"late Third or early Fourth Quarter of 2026\", \"late 2026\", \"November 2026\", \"third quarter of 2026\".",
          "buildingsOperational": 20.0,
          "itPowerMw": 854.0,
          "h100Equivalent": 1030823.6483072259,
          "capitalCostB": 32.351228
        }
      ]
    },
    {
      "name": "Anthropic-Amazon New Carlisle",
      "slug": "anthropic-amazon-new-carlisle",
      "owner": "Amazon",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "55001 Larrison Blvd, New Carlisle, IN 46552",
      "project": "Project Rainier #confident",
      "currentChipTypes": [
        "Trainium2"
      ],
      "allChipTypes": [
        "Trainium2"
      ],
      "currentPowerMw": 910.0,
      "currentH100Equivalent": 685912.076806468,
      "currentCapitalCostB": 34.47262,
      "timeline": [
        {
          "date": "2024-02-09",
          "status": "Land clearing begins in the northern section",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-06-10",
          "status": "Land clearing begins in the southern section",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-05-10",
          "status": "Roof complete on building 11",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-23",
          "status": "Buildings 1-7 are operational. Based on all of the roofs being completed for over 5 months.",
          "buildingsOperational": 7.0,
          "itPowerMw": 398.0,
          "h100Equivalent": 300151.59171298635,
          "capitalCostB": 15.077036
        },
        {
          "date": "2025-09-26",
          "status": "Roof complete on building 16. Generators are being installed for buildings 8-15. In the north, Building 17 and 18 are under construction. To the south of buildings 8-16, a concrete pad is visible, and an expanded car park next to it.",
          "buildingsOperational": 7.0,
          "itPowerMw": 398.0,
          "h100Equivalent": 300151.59171298635,
          "capitalCostB": 15.077036
        },
        {
          "date": "2025-10-17",
          "status": "Confirmation that nearly 500,000 chips are operational, which fits buildings 1-7. In an [interview](https://www.youtube.com/watch?v=jwgW_gHI1Vs&t=220s), AWS CEO says \"they're already running...about 500,000 [Trainium2] chips in Indiana today\".",
          "buildingsOperational": 7.0,
          "itPowerMw": 398.0,
          "h100Equivalent": 300151.59171298635,
          "capitalCostB": 15.077036
        },
        {
          "date": "2025-12-23",
          "status": "Buildings 8-11 are operational, given it's been over 7 months since their roofs were complete, and the backup generators and roof chimneys look complete. The roof is almost complete for Building 17 and 18.",
          "buildingsOperational": 11.0,
          "itPowerMw": 626.0,
          "h100Equivalent": 471450.2273875695,
          "capitalCostB": 23.714132
        },
        {
          "date": "2026-02-09",
          "status": "Buildings 12-16 still have a few generators that look incomplete, so they are unlikely to be operational just yet. Buildings 17-18 still have ongoing roof work, no generators. Just south of Buildings 9-16, the outlines of a site for Buildings 19-32 are taking shape.",
          "buildingsOperational": 11.0,
          "itPowerMw": 626.0,
          "h100Equivalent": 471450.2273875695,
          "capitalCostB": 23.714132
        },
        {
          "date": "2026-03-23",
          "status": "Buildings 12-16 are operational. Based on how long previous buildings took, when they were in a similar state to Buildings 12-16 in December.",
          "buildingsOperational": 16.0,
          "itPowerMw": 910.0,
          "h100Equivalent": 685912.076806468,
          "capitalCostB": 34.47262
        },
        {
          "date": "2026-06-03",
          "status": "Buildings 17-18 fully roofed but still having surrounding generators/cooling under construction. Cleared land for buildings 19-32 is still bare, with no building foundations visible yet. Based on satellite imagery.",
          "buildingsOperational": 16.0,
          "itPowerMw": 910.0,
          "h100Equivalent": 685912.076806468,
          "capitalCostB": 34.47262
        },
        {
          "date": "2026-10-19",
          "status": "Buildings 17-18 are operational. This is an estimate based on a rule of thumb of \"operational 5 months after roof is complete\", assuming the roofs took one more month after 2025-12-23. Also added four more months to account for commissioning and adjacent cooling units not being complete yet.",
          "buildingsOperational": 18.0,
          "itPowerMw": 1037.0,
          "h100Equivalent": 818428.4992420415,
          "capitalCostB": 39.283634
        },
        {
          "date": "2028-03-17",
          "status": "Buildings 19-32 are operational. This is an estimate based on how long Buildings 1-16 took to become operational. In May 2026, the foundation of several buildings and a substation was visible at the site of Buildings 19-32. Buildings 1-16 took 1 year and 10 months to go from a similar state to operational. So we add 1 year and 10 months to May 2026 to get this date estimate. The power capacity is based on an [air quality permit](https://t.co/HsAO7oyKa2) filed in May 2026, and the compute capacity is based on Trainium3 chips.",
          "buildingsOperational": 32.0,
          "itPowerMw": 1925.0,
          "h100Equivalent": 1746038.4032339565,
          "capitalCostB": 72.92285
        }
      ]
    },
    {
      "name": "OpenAI Stargate Abilene",
      "slug": "openai-stargate-abilene",
      "owner": "Oracle",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "5502 Spinks Rd, Abilene, TX 79601",
      "project": "Stargate #confident",
      "currentChipTypes": [
        "B200",
        "B300"
      ],
      "allChipTypes": [
        "B200",
        "B300"
      ],
      "currentPowerMw": 421.0,
      "currentH100Equivalent": 509348.15563415864,
      "currentCapitalCostB": 15.948322,
      "timeline": [
        {
          "date": "2024-05-31",
          "status": "Land clearing begins for northern two buildings (Building 1-2)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-28",
          "status": "Building 1 looks close to finishing construction, with chillers in place. OpenAI [stated](https://openai.com/index/five-new-stargate-sites/) that \"Oracle began delivering the first NVIDIA GB200 racks in June.\" The \"tenant improvement\" work [is not due](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025000156) until September, however.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-26",
          "status": "Building 1 is fully operational around this date. The first phase was \"live\" on September 30 according a Crusoe [announcement](https://www.crusoe.ai/resources/newsroom/crusoe-announces-flagship-abilene-data-center-is-live). While the first phase consists of Building 1 and 2, the language doesn't outright confirm that both buildings are fully operational. The announcement also stated that \"Oracle began delivering the first NVIDIA GB200 racks in June\", and we think 3 months is enough time to ram to 50,000 GB200s in Building 1. The satellite image also suggests that Building 1 is complete (shell and equipment done, many cars neatly parked) while Building 2 is ongoing (trucks and construction equipment still present). The 200 MW [substation](https://www.mortenson.com/projects/abilene-data-center-development) built in 2022 and expanded in 2024 is enough to power both buildings. To the right of Building 2, five gas turbines are in place with five more turbines still under construction. Chillers are partly installed for Building 3. Roof is complete for Building 4. The larger 1 GW substation is not complete yet.",
          "buildingsOperational": 1.0,
          "itPowerMw": 105.0,
          "h100Equivalent": 127337.03890853966,
          "capitalCostB": 3.9776099999999994
        },
        {
          "date": "2025-12-24",
          "status": "Building 2 is fully operational. This exact date corresponds to the expected completion date of \"Four (4) data hall spaces and an administrative office build-out\" according to a [TDLR filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025007742), but this date is also consistent with satellite imagery. By January 15, Building 2 looked as finished as Building 1, whereas on September 26 it did not look finished.",
          "buildingsOperational": 2.0,
          "itPowerMw": 211.0,
          "h100Equivalent": 254674.07781707932,
          "capitalCostB": 7.993102
        },
        {
          "date": "2026-01-15",
          "status": "The 1 GW substation looks close to completion. Building 3 appears to have all power and cooling equipment installed, but there are still signs of construction work. This seems on track for operation in 3 months. Building 4 has about 80% of chillers installed. Other buildings have few or no chillers installed.",
          "buildingsOperational": 2.0,
          "itPowerMw": 211.0,
          "h100Equivalent": 254674.07781707932,
          "capitalCostB": 7.993102
        },
        {
          "date": "2026-03-24",
          "status": "Building 3 and 4 look complete, but are not fully operational. Not as many cars are parked next to it as Building 1-2 which suggests they may still be ramping up. Building 4 was due by now according to a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025014756). Building 5 still has light construction activity, while Building 6 still lacks chillers. The on-site power plant to the right of Building 2 looks complete.",
          "buildingsOperational": 2.0,
          "itPowerMw": 211.0,
          "h100Equivalent": 254674.07781707932,
          "capitalCostB": 7.993102
        },
        {
          "date": "2026-05-23",
          "status": "Buildings 3 and 4 are estimated to be operational. On April 22nd, Oracle [posted](https://x.com/i/status/2047012589302153558) that \"In Abilene, 200MW is already operational\". This suggests that there was still only Building 1 and 2 operational. Since Buildings 3 and 4 looked complete from the outside on March 24th, we give it another month after Oracle's post for them to be operational. This would also give the buildings a similar 1 year 4 months timeline that Buildings 1 took from land clearing to being operational.",
          "buildingsOperational": 4.0,
          "itPowerMw": 421.0,
          "h100Equivalent": 509348.15563415864,
          "capitalCostB": 15.948322
        },
        {
          "date": "2026-11-01",
          "status": "Buildings 5-8 are estimated to be operational. On March 24, Building 8 roughly looked like where Building 3 was in September. Building 3 is estimated to be operational in April, 7 months later. This naively suggests Building 8 will be operational by early November, 7 months after March 24.",
          "buildingsOperational": 8.0,
          "itPowerMw": 843.0,
          "h100Equivalent": 1018696.3112683173,
          "capitalCostB": 31.934525999999998
        }
      ]
    },
    {
      "name": "Microsoft Fairwater Wisconsin",
      "slug": "microsoft-fairwater-wisconsin",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "likely"
        },
        {
          "name": "Microsoft",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "4800 90th St, Mount Pleasant, WI 53403",
      "project": "Microsoft AI WAN #confident",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 369.0,
      "currentH100Equivalent": 445679.63617988885,
      "currentCapitalCostB": 13.978458,
      "timeline": [
        {
          "date": "2023-07-14",
          "status": "Land clearing begins for Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-26",
          "status": "Building 1 cooling and backup generators all look complete from above but there is still construction visible around the building. Building 2 is well underway with a foundation and a complete substation. Large carpark and concrete area north of Building 2. Building 3 has a concrete foundation and a substation underway.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-28",
          "status": "Building 1 looks complete, but based on Microsoft announcements, it's not fully operational yet. Steel framing is underway for Building 2.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-16",
          "status": "Building 1 is operational. [X post](https://x.com/satyanadella/status/2044767391293509761?s=61) from Microsoft saying this date for Fairwater becoming operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 369.0,
          "h100Equivalent": 445679.63617988885,
          "capitalCostB": 13.978458
        },
        {
          "date": "2026-05-15",
          "status": "The main shell of Building 2 looks almost completed. In Area 2 (northwest of Buildings 1-2), the grading for the original design has been replaced with grading for the new [9-building design](https://www.mtpleasantwi.gov/AgendaCenter/ViewFile/Agenda/_01212026-1292), making way for Buildings 3-11. Work continues on the northern substation in Area 2.",
          "buildingsOperational": 1.0,
          "itPowerMw": 369.0,
          "h100Equivalent": 445679.63617988885,
          "capitalCostB": 13.978458
        },
        {
          "date": "2027-02-20",
          "status": "Building 2 is operational. This is estimated based on (1) the delay between Building 1 and Building 2 starting land clearing, (2) in March 2025, a Microsoft spokesperson [said](https://www.wpr.org/news/microsoft-pauses-construction-on-parts-of-mount-pleasant-site-again) “fully on track” with the first phase , where “southern datacenter buildings complete, and preparation begins for operations” was [expected](https://local.microsoft.com/blog/mount-pleasant-datacenter-project-update/) by late 2026. Finally, while it's not 100% consistent with our estimates, MISO was [planning](https://cdn.misoenergy.org/NEW%20LOAD%20ANNOUNCEMENTS%20IN%20MISO%20REGIONS%2012062024684954.pdf) 1480 MW of load for Microsoft in Mount Pleasant in 2026.",
          "buildingsOperational": 2.0,
          "itPowerMw": 737.0,
          "h100Equivalent": 889338.0495199596,
          "capitalCostB": 27.919033999999996
        },
        {
          "date": "2028-05-13",
          "status": "Buildings 3-11 are estimated to be operational. The grading for this revised 9-building plan was underway in May 2026, and we assume an average 2-year [build time](https://epoch.ai/data-insights/data-centers-buildout-speeds) from that point.",
          "buildingsOperational": 11.0,
          "itPowerMw": 2263.0,
          "h100Equivalent": 4527539.161192521,
          "capitalCostB": 85.72696599999999
        }
      ]
    },
    {
      "name": "Google Columbus",
      "slug": "google-columbus",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "5076 S High St, Columbus, OH 43207",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "currentPowerMw": 303.0,
      "currentH100Equivalent": 408792.3193532087,
      "currentCapitalCostB": 11.478245999999999,
      "timeline": [
        {
          "date": "2021-10-01",
          "status": "Land clearing begins on the eastern half of the site, for Buildings 1-2",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-07-01",
          "status": "Building 2 foundation work begins. Building 1 generators seem complete, cooling towers still under construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-04-01",
          "status": "Building 1 operational. No visible construction and roads/parking complete around the building. Building 2 chillers are beginning construction. Foundation work begins for Building 3.",
          "buildingsOperational": 1.0,
          "itPowerMw": 65.0,
          "h100Equivalent": 32541.68772107125,
          "capitalCostB": 2.46233
        },
        {
          "date": "2025-03-01",
          "status": "Building 2 operational. Parking complete, no more visible construction.",
          "buildingsOperational": 2.0,
          "itPowerMw": 130.0,
          "h100Equivalent": 111672.56189994948,
          "capitalCostB": 4.92466
        },
        {
          "date": "2025-10-01",
          "status": "Building 3 operational. Surrounding roads finished, no more visible construction.",
          "buildingsOperational": 3.0,
          "itPowerMw": 216.0,
          "h100Equivalent": 232945.93228903486,
          "capitalCostB": 8.182512
        },
        {
          "date": "2026-02-21",
          "status": "Buildings 1-3 are visibly operational, with steam coming out of the cooling towers. Meanwhile Building 4 is extremely close to completion, with all backup generators complete with only 3 cooling towers missing their fans. ~1/2 the generators are installed for Building 5, and the roof is mostly complete (starting to install the final white layer, with the actual roof structure already complete).",
          "buildingsOperational": 3.0,
          "itPowerMw": 216.0,
          "h100Equivalent": 232945.93228903486,
          "capitalCostB": 8.182512
        },
        {
          "date": "2026-05-01",
          "status": "Building 4 operational. No more visible construction, and since only 3 fans needed to be installed since Feburary, operational date was likely soon after. Building 5 roof almost complete.",
          "buildingsOperational": 4.0,
          "itPowerMw": 303.0,
          "h100Equivalent": 408792.3193532087,
          "capitalCostB": 11.478245999999999
        },
        {
          "date": "2027-07-01",
          "status": "Building 5 operational. The [transmission line construction notice](https://www.aeptransmission.com/ohio/docs/Hartman%20Farms%20Extension%20No.%202%20138%20kV%20Transmission%20Line%20Project%20Construction%20Notice.pdf) that expands site by 100 MW is assumed to be entirely for Building 5, and has an in-service date of July 1, 2027 (page 3). Estimate taken on the safe side based on completion times for Building 3-4 from when roof was complete.",
          "buildingsOperational": 5.0,
          "itPowerMw": 386.0,
          "h100Equivalent": 707427.9939363315,
          "capitalCostB": 14.622452
        }
      ]
    },
    {
      "name": "Google New Albany",
      "slug": "google-new-albany",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "1101 Beech Rd SW, New Albany, OH 43054",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "currentPowerMw": 339.0,
      "currentH100Equivalent": 351692.77412834764,
      "currentCapitalCostB": 12.841998,
      "timeline": [
        {
          "date": "2024-04-20",
          "status": "Building 1 is operational. Based on ~7 months since roof being completed, and cooling towers being installed sometime within that period. Building 2 roof is complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 34057.60485093482,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2024-09-13",
          "status": "Building 2 is operational. Google Earth imagery shows 6 cooling towers installed as of 2024-04-20, and a final 7th unit appeared as of 2024-09-13, with minimal construction around the building. Building 3 roof is also complete.",
          "buildingsOperational": 2.0,
          "itPowerMw": 147.0,
          "h100Equivalent": 82364.83072258717,
          "capitalCostB": 5.5686539999999995
        },
        {
          "date": "2025-06-01",
          "status": "Building 3 is operational, based on all cooling units and tanks installed, minimal construction work around the building. Building 4 still has some work around the cooling towers. Work is underway on Building 5 - some walls and a few backup generators are in place.",
          "buildingsOperational": 3.0,
          "itPowerMw": 226.0,
          "h100Equivalent": 193026.78120262758,
          "capitalCostB": 8.561332
        },
        {
          "date": "2025-10-14",
          "status": "Building 4 is operational, based on all cooling units and tanks installed, minimal construction work around the building. Building 5 roof is half complete. About half of the backup generators are in place. One cooling tower is partly built.",
          "buildingsOperational": 4.0,
          "itPowerMw": 339.0,
          "h100Equivalent": 351692.77412834764,
          "capitalCostB": 12.841998
        },
        {
          "date": "2026-01-18",
          "status": "Water vapor from cooling towers is present across Building 1-4, confirming their operation. Building 5 roof is still incomplete, but most backup generators and 5 cooling towers have been installed.",
          "buildingsOperational": 4.0,
          "itPowerMw": 339.0,
          "h100Equivalent": 351692.77412834764,
          "capitalCostB": 12.841998
        },
        {
          "date": "2026-03-12",
          "status": "Building 5 has more cooling towers installed but not complete, and the roof is almost complete.",
          "buildingsOperational": 4.0,
          "itPowerMw": 339.0,
          "h100Equivalent": 351692.77412834764,
          "capitalCostB": 12.841998
        },
        {
          "date": "2026-05-18",
          "status": "Building 5 has all cooling towers installed, and all other components look complete, but there is still light work around the building. Based on that, we estimate 3 more months until operational.",
          "buildingsOperational": 4.0,
          "itPowerMw": 339.0,
          "h100Equivalent": 351692.77412834764,
          "capitalCostB": 12.841998
        },
        {
          "date": "2026-08-16",
          "status": "Building 5 is operational. Estimated from the high-res image from May.",
          "buildingsOperational": 5.0,
          "itPowerMw": 453.0,
          "h100Equivalent": 616472.9661445174,
          "capitalCostB": 17.160546
        }
      ]
    },
    {
      "name": "Google Council Bluffs (East)",
      "slug": "google-council-bluffs-east",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "10410 Bunge Ave, Council Bluffs, IA 51503",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v6e",
        "TPU v5p",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v6e",
        "TPU v5p",
        "TPU v7"
      ],
      "currentPowerMw": 237.0,
      "currentH100Equivalent": 339060.1313794846,
      "currentCapitalCostB": 8.978034,
      "timeline": [
        {
          "date": "2022-09-06",
          "status": "Land clearing begins for east buildings",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-11-19",
          "status": "Building 1 is operational. Google Earth shows Building 1 had all backup generators and cooling towers installed by the end of August, but construction work was ongoing and there were almost no cars parked. By February 2025, Google Earth shows no construction work and many cars. So our best guess is in the middle, in November 2024. Building 3 roof is complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 79.0,
          "h100Equivalent": 68216.27084386053,
          "capitalCostB": 2.992678
        },
        {
          "date": "2025-06-15",
          "status": "Building 2 is operational. Assuming it takes 3 months after generators and cooling towers are finished, similar to Building 1.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 178878.22132390097,
          "capitalCostB": 5.985356
        },
        {
          "date": "2025-07-19",
          "status": "Land clearing begins in the southwest, suggesting more buildings are planned.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 178878.22132390097,
          "capitalCostB": 5.985356
        },
        {
          "date": "2026-01-11",
          "status": "Building 3 has all 34 backup generators installed and 4 cooling towers installed, with 3 more cooling towers under construction. There are gaps between cooling towers suggesting that more could be added. Buildings 1 and 2 are running close to full capacity, given that water vapor is coming out of 5 of 7 cooling towers for each building. The land cleared in the southwest appears to be shaped for two more similar buildings, with notches for substations.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 178878.22132390097,
          "capitalCostB": 5.985356
        },
        {
          "date": "2026-07-07",
          "status": "Building 3 confirmed operational. 7 cooling towers were finally installed despite being more spread out compared to the first two buildings. Cooling towers models vary slightly between buildings. Ground clearing to the southwest seems to be setting up for two more buildings.",
          "buildingsOperational": 3.0,
          "itPowerMw": 237.0,
          "h100Equivalent": 339060.1313794846,
          "capitalCostB": 8.978034
        }
      ]
    },
    {
      "name": "Google Lincoln",
      "slug": "google-lincoln",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "5475 Cloud Ct, Lincoln, NE 68514",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 141.0,
      "currentH100Equivalent": 287518.9489641233,
      "currentCapitalCostB": 5.341361999999999,
      "timeline": [
        {
          "date": "2023-07-01",
          "status": "Land clearing begins for the site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-23",
          "status": "Building 1 looks mostly complete: the large items like generators and substation are done. It is just missing 2 more cooling towers (4 fans). They just seem to be paving and setting up the secondary equipment so it is probably a few months away from operation. Building 2 foundation has been laid.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-12",
          "status": "Building 1 operational. This is based on the fact that is no more visible equipment or construction around the building, and based on previous imagery and when construction started on the last pieces of equipment (fans). Building 2's roof is complete, with generator construction more than halfway complete and cooling construction beginning. Electrical equipment on the side of Building 2 is also around halfway complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 141.0,
          "h100Equivalent": 287518.9489641233,
          "capitalCostB": 5.341361999999999
        },
        {
          "date": "2027-10-01",
          "status": "Building 2 operational. Estimated based on the construction timeline for Building 1, specifically the time to operational since the roof was complete and the time to operational since the foundation work began.",
          "buildingsOperational": 2.0,
          "itPowerMw": 283.0,
          "h100Equivalent": 869125.8211217787,
          "capitalCostB": 10.720606
        }
      ]
    },
    {
      "name": "Google Bristow",
      "slug": "google-bristow",
      "owner": "Google",
      "ownerConfidence": "unknown",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "unknown"
        }
      ],
      "country": "United States",
      "address": "13001 Rollins Ford Road, Bristow, VA 20136",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e",
        "TPU v7"
      ],
      "currentPowerMw": 279.0,
      "currentH100Equivalent": 283675.08842849924,
      "currentCapitalCostB": 10.569078000000001,
      "timeline": [
        {
          "date": "2021-07-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-04-29",
          "status": "Building 1 is operational, based off of colored motion artifacts from cooling towers. Building 2 is undergoing construction.",
          "buildingsOperational": 1.0,
          "itPowerMw": 99.0,
          "h100Equivalent": 49886.6599292572,
          "capitalCostB": 3.750318
        },
        {
          "date": "2025-04-29",
          "status": "Building 2 is operational, based off it being at least 12 months since the roof was complete. Building 3 is finishing construction of cooling towers.",
          "buildingsOperational": 2.0,
          "itPowerMw": 198.0,
          "h100Equivalent": 170973.21879737242,
          "capitalCostB": 7.500636
        },
        {
          "date": "2026-05-20",
          "status": "Building 3 is operational, based off of colored motion artifacts from cooling towers.",
          "buildingsOperational": 3.0,
          "itPowerMw": 279.0,
          "h100Equivalent": 283675.08842849924,
          "capitalCostB": 10.569078000000001
        }
      ]
    },
    {
      "name": "DayOne Nusajaya",
      "slug": "dayone-nusajaya",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "Malaysia",
      "address": "",
      "project": "",
      "currentChipTypes": [
        "H100",
        "B300"
      ],
      "allChipTypes": [
        "H100",
        "B300"
      ],
      "currentPowerMw": 240.0,
      "currentH100Equivalent": 281670.4396159676,
      "currentCapitalCostB": 9.09168,
      "timeline": [
        {
          "date": "2023-10-01",
          "status": "Construction for Building 1-2 is underway.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-12-31",
          "status": "Buildings 1-2 are fully operational. Based on DayOne [reporting](https://web.archive.org/web/20241231165420/https://dayonedc.com/) that 120 MW is in operation in Johor, with [50 MW](https://www.moomoo.com/news/post/41886329/support-ai-computing-deployment-gds-holdings-nusajaya-technology-park-datacenter?level=1&data_ticket=1778269491837872) towards these two buildings. The date is based on the earliest available archived webpage, so this may have happened earlier.",
          "buildingsOperational": 2.0,
          "itPowerMw": 50.0,
          "h100Equivalent": 34399.727134916626,
          "capitalCostB": 1.8941
        },
        {
          "date": "2026-01-22",
          "status": "Buildings 3-6 are operational, based on them looking complete. DayOne [reported](https://archive.is/8CFXN) that 390 MW is \"in service\" in Johor as of Jan 30. This is across both Nusajaya (including Phase 1, which we don't include here) and Kempas, but Nusajaya is the vast majority of capacity at this time. Building 7 and 8 look almost complete, while Building 9 and 10 shells are still under construction.",
          "buildingsOperational": 6.0,
          "itPowerMw": 240.0,
          "h100Equivalent": 281670.4396159676,
          "capitalCostB": 9.09168
        },
        {
          "date": "2026-04-05",
          "status": "Buildings 7-10 look mostly complete, but there is still some construction work at the edges.",
          "buildingsOperational": 6.0,
          "itPowerMw": 240.0,
          "h100Equivalent": 281670.4396159676,
          "capitalCostB": 9.09168
        },
        {
          "date": "2026-10-02",
          "status": "Buildings 7-10 are operational. Judging by their state in April 2026, we expect 3 months to finish construction and another 3 months to ramp to full capacity.",
          "buildingsOperational": 10.0,
          "itPowerMw": 473.0,
          "h100Equivalent": 583836.7862556847,
          "capitalCostB": 17.918186
        }
      ]
    },
    {
      "name": "Colossus 1",
      "slug": "colossus-1",
      "owner": "SpaceXAI",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "3231 Riverport Rd, Memphis, TN 38109",
      "project": "",
      "currentChipTypes": [
        "H100",
        "H200",
        "B200"
      ],
      "allChipTypes": [
        "H100",
        "H200",
        "B200"
      ],
      "currentPowerMw": 340.0,
      "currentH100Equivalent": 275795.85649317835,
      "currentCapitalCostB": 12.87988,
      "timeline": [
        {
          "date": "2024-04-24",
          "status": "Construction starts with a road added on site, retrofitting a former Electrolux building.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-08-11",
          "status": "First [significant/useful training workload](https://x.ai/colossus) on 25k H100s.",
          "buildingsOperational": 1.0,
          "itPowerMw": 35.0,
          "h100Equivalent": 25000.0,
          "capitalCostB": 1.32587
        },
        {
          "date": "2024-09-02",
          "status": "[100k H100s online](https://archive.is/z39uN).",
          "buildingsOperational": 1.0,
          "itPowerMw": 139.0,
          "h100Equivalent": 100000.0,
          "capitalCostB": 5.265598000000001
        },
        {
          "date": "2025-02-17",
          "status": "150k H100s and 50k H200s online. This is roughly when [Musk](https://archive.is/z39uN) [said](https://archive.is/z39uN), plus on this date they reported \"running jobs with 150K+ GPUs\".",
          "buildingsOperational": 1.0,
          "itPowerMw": 278.0,
          "h100Equivalent": 200000.0,
          "capitalCostB": 10.531196000000001
        },
        {
          "date": "2025-03-06",
          "status": "Second substation almost connected (red cables)",
          "buildingsOperational": 1.0,
          "itPowerMw": 278.0,
          "h100Equivalent": null,
          "capitalCostB": 10.531196000000001
        },
        {
          "date": "2025-07-22",
          "status": "30k B200s [added](https://archive.is/oHQSA) (in GB200 configuration).",
          "buildingsOperational": 1.0,
          "itPowerMw": 340.0,
          "h100Equivalent": 275795.85649317835,
          "capitalCostB": 12.87988
        },
        {
          "date": "2025-09-17",
          "status": "Third substation looks completed, but it doesn't appear to be connected to the building yet. Some air-cooled chillers removed, while large cooling towers are added.",
          "buildingsOperational": 1.0,
          "itPowerMw": 268.0,
          "h100Equivalent": 209125.08068426175,
          "capitalCostB": 10.152376
        },
        {
          "date": "2025-10-19",
          "status": "There is still construction visible in the third substation yard and next to the new cooling towers.",
          "buildingsOperational": 1.0,
          "itPowerMw": 268.0,
          "h100Equivalent": 209125.08068426175,
          "capitalCostB": 10.152376
        },
        {
          "date": "2025-11-07",
          "status": "Third substation was expected to power the building in Fall.",
          "buildingsOperational": 1.0,
          "itPowerMw": 340.0,
          "h100Equivalent": 275795.85649317835,
          "capitalCostB": 12.87988
        },
        {
          "date": "2026-02-11",
          "status": "All air-cooled chillers have been disconnected and/or removed from the site, leaving only the cooling towers for cooling. The third substation looks complete, with red cables connected to the building.",
          "buildingsOperational": 1.0,
          "itPowerMw": 340.0,
          "h100Equivalent": 275795.85649317835,
          "capitalCostB": 12.87988
        },
        {
          "date": "2026-05-06",
          "status": "Anthropic [announces](https://www.anthropic.com/news/higher-limits-spacex) their agreement with SpaceX to use all of the compute capacity at Colossus 1. They state that this corresponds to more than 300 MW (presumably IT power) and over 220,000 GPUs. This is slightly different to previous reports adding up to 230,000 GPUs, but still roughly consistent with our estimates.",
          "buildingsOperational": 1.0,
          "itPowerMw": 340.0,
          "h100Equivalent": 275795.85649317835,
          "capitalCostB": 12.87988
        },
        {
          "date": "2026-06-15",
          "status": "No major changes to the data center since February. Solar panels have been placed next to the facility.",
          "buildingsOperational": 1.0,
          "itPowerMw": 340.0,
          "h100Equivalent": 275795.85649317835,
          "capitalCostB": 12.87988
        }
      ]
    },
    {
      "name": "Google Omaha",
      "slug": "google-omaha",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "11110 State St, Omaha, NE 68142",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v6e"
      ],
      "currentPowerMw": 237.0,
      "currentH100Equivalent": 267812.02627589693,
      "currentCapitalCostB": 8.978034,
      "timeline": [
        {
          "date": "2021-11-25",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-04-08",
          "status": "Building 1 operational, based on it being 6 months after roof was complete, infrastructure looked complete for 5 months.",
          "buildingsOperational": 1.0,
          "itPowerMw": 79.0,
          "h100Equivalent": 39565.43708943911,
          "capitalCostB": 2.992678
        },
        {
          "date": "2024-07-29",
          "status": "Building 2 has 3 cooling towers installed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 79.0,
          "h100Equivalent": 39565.43708943911,
          "capitalCostB": 2.992678
        },
        {
          "date": "2024-11-19",
          "status": "Building 2 is operational, based on it being 8 months since the roof was complete, and surrounding infrastructure looks just completed (finishing the cooling towers).",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 107630.11622031328,
          "capitalCostB": 5.985356
        },
        {
          "date": "2025-03-16",
          "status": "Confirmation that there's no obvious construction happening for Building 2. Building 3 roof started.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 107630.11622031328,
          "capitalCostB": 5.985356
        },
        {
          "date": "2025-04-21",
          "status": "Confident that Building 2 is operational",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 107630.11622031328,
          "capitalCostB": 5.985356
        },
        {
          "date": "2025-10-21",
          "status": "Building 3 has all backup generators in place but they are still being installed. Two cooling towers have fans on them, with more underway. To the south of Building 3, more land has been cleared and there's a new carpark. This suggests another building will soon start construction.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 107630.11622031328,
          "capitalCostB": 5.985356
        },
        {
          "date": "2026-05-15",
          "status": "Building 3 appears almost complete, with only minimal construction work and equipment remaining. The cooling towers are spaced apart in an unusual way, but there's no obvious sign that more will be installed before operation. Buildings 4 and 5 haven't started construction yet, the cleared land is still empty.",
          "buildingsOperational": 2.0,
          "itPowerMw": 158.0,
          "h100Equivalent": 107630.11622031328,
          "capitalCostB": 5.985356
        },
        {
          "date": "2026-06-30",
          "status": "Building 3 is operational (estimate). Based on there being minimal construction work as of May 15.",
          "buildingsOperational": 3.0,
          "itPowerMw": 237.0,
          "h100Equivalent": 267812.02627589693,
          "capitalCostB": 8.978034
        },
        {
          "date": "2028-01-23",
          "status": "Building 4 is operational. Expect a 4th building because there's enough land cleared for it. Assuming the foundation starts at the end of May 2026 and it takes a similar time to Building 3 from foundation to operational (1 year 8 months).",
          "buildingsOperational": 4.0,
          "itPowerMw": 316.0,
          "h100Equivalent": 641738.2516422436,
          "capitalCostB": 11.970712
        },
        {
          "date": "2028-07-23",
          "status": "Building 5 is operational. We expect a 5th building because there's enough land cleared for one. We assume a roughly 6-month delay after Building 4.",
          "buildingsOperational": 5.0,
          "itPowerMw": 395.0,
          "h100Equivalent": 1136937.8473976755,
          "capitalCostB": 14.96339
        }
      ]
    },
    {
      "name": "CoreWeave Denton TX",
      "slug": "coreweave-denton-tx",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "8171 Jim Christal Rd, Denton, TX 76207",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 262.0,
      "currentH100Equivalent": 252652.85497726125,
      "currentCapitalCostB": 9.925084,
      "timeline": [
        {
          "date": "2024-11-01",
          "status": "Construction start - The [Texas Department of Licensing and Regulation](https://www.tdlr.texas.gov/TABS/Search/Print/TABS2025005706) reports Core Scientific is converting existing Bitcoin mining buildings into AI data centers, planning to build AROUND the existing Denton Energy Center.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-05-31",
          "status": "First 8 MW billable tranche dedicated to AI [starts running at the site](https://investors.corescientific.com/sec-filings/all-sec-filings/content/0001628280-25-023161/q12025corescientificinc-ea.htm), with another 40 scheduled by the end of the quarter.",
          "buildingsOperational": 1.0,
          "itPowerMw": 8.0,
          "h100Equivalent": 7781.707933299646,
          "capitalCostB": 0.303056
        },
        {
          "date": "2025-12-31",
          "status": "Half the campus energized. 67 billable MW [are now dedicated](https://d1io3yog0oux5.cloudfront.net/_68280da94b2098ec46fcbe3f4628ea40/corescientific/db/1085/11265/presentation/Q4+FY25+earnings+deck+vfinal.2+PDF.pdf) to CoreWeave's GPUs across three buildings.",
          "buildingsOperational": 3.0,
          "itPowerMw": 67.0,
          "h100Equivalent": 64679.13087417888,
          "capitalCostB": 2.538094
        },
        {
          "date": "2026-02-23",
          "status": "Buildings 1-3 (Denton North) are largely built out/operational, and Denton South has its first data hall plus support equipment substantially installed. Remaining Denton South buildings (4-7) still under construction. This is according to satellite imagery.",
          "buildingsOperational": 4.0,
          "itPowerMw": 131.0,
          "h100Equivalent": 126326.42748863062,
          "capitalCostB": 4.962542
        },
        {
          "date": "2026-03-02",
          "status": "Buildings 1-3 (Denton North) are fully operational running AI (Denton North at 90 MW, Denton South partially running at 41). This is according to an [earnings call](https://www.fool.com/earnings/call-transcripts/2026/03/02/core-scientific-corz-q4-2025-earnings-transcript/) from this date.",
          "buildingsOperational": 4.0,
          "itPowerMw": 131.0,
          "h100Equivalent": 126326.42748863062,
          "capitalCostB": 4.962542
        },
        {
          "date": "2026-07-03",
          "status": "Full campus of 7 data halls are operational and running, with no construction work visible. This is based on both satellite imagery, and the [Q2 2026 Earnings call](https://d1io3yog0oux5.cloudfront.net/_68280da94b2098ec46fcbe3f4628ea40/corescientific/db/1066/11282/pdf/Q2+FY26+earnings+deck+7.28+AM.pdf) stating the campus was operational by midyear 2026.",
          "buildingsOperational": 7.0,
          "itPowerMw": 262.0,
          "h100Equivalent": 252652.85497726125,
          "capitalCostB": 9.925084
        }
      ]
    },
    {
      "name": "Google Kansas City East",
      "slug": "google-kansas-city-east",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 105.0,
      "currentH100Equivalent": 244567.9636179889,
      "currentCapitalCostB": 3.9776099999999994,
      "timeline": [
        {
          "date": "2024-01-01",
          "status": "Land clearing has begun for the site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-03-01",
          "status": "Foundation work begins on Building 1",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-10-01",
          "status": "Foundation work begins on Building 2. Building 1 roof is fully black.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-07-01",
          "status": "Foundation work begins for Building 3. Building 1 generators seem complete.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-11-01",
          "status": "Foundation work begins for Building 4. Building 2 roof is almost complete, and construction appears to have started on cooling. Building 1 cooling construction continues, and the substation right next to it seems finished as well.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-16",
          "status": "Building 1 is almost complete, with only cooling needing 4 more fans. Building 2 backup generator construction has begun, and cooling tower installation is about halfway complete. Building 3's roof is almost complete, and construction has started on generators and cooling. A clear foundation has been cleared for Building 4, though no construction has begun.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-08-01",
          "status": "Building 1 operational. Estimated based on present construction progress and typical timelines.",
          "buildingsOperational": 1.0,
          "itPowerMw": 105.0,
          "h100Equivalent": 244567.9636179889,
          "capitalCostB": 3.9776099999999994
        }
      ]
    },
    {
      "name": "QTS Richmond 1",
      "slug": "qts-richmond-1",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "6000 Technology Blvd, Sandston, VA 23150",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 238.0,
      "currentH100Equivalent": 242546.7407781708,
      "currentCapitalCostB": 9.015915999999999,
      "timeline": [
        {
          "date": "2023-10-01",
          "status": "Land cleared for site expansion, some materials down at substation site. We assume that Buildings 1 and 2 are not running AI workloads at this point due to the lack of cooling infrastructure.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-11-02",
          "status": "Building 1 and 2 retrofitting has begun (see [Google Earth](https://earth.google.com/web/@37.48913637,-77.24705465,44.31788662a,1464.06665017d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDIzLTExLTAyGAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE)). Building 1 has chillers added to the roof and perimeter, and backup generators added to the perimeter.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-01-29",
          "status": "Building 1 (retrofitted) is operational. This is based on it looking complete, and cooling towers possibly showing water vapor plumes, in this [Google Earth image](https://earth.google.com/web/@37.4875167,-77.24806799,43.67572425a,2395.6622579d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDI0LTAyLTA2GAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE). Building 2 has chillers added to the roof and perimeter, and backup generators added to the perimeter. Cooling towers near Building 2 have been removed. Building 3 shell is under construction.",
          "buildingsOperational": 1.0,
          "itPowerMw": 47.0,
          "h100Equivalent": 33855.482566953004,
          "capitalCostB": 1.7804540000000002
        },
        {
          "date": "2024-06-23",
          "status": "Building 2 (retrofitted) is operational. This is based on Building 2 looking compelte, and construction around Building 1 and 2 being mostly cleared. A colored motion artifact on one of the Building 1 cooling tower fans suggests it is moving. Building 3 cooling is installed, backup generators partly installed. Building 4 shell is under construction.",
          "buildingsOperational": 2.0,
          "itPowerMw": 94.0,
          "h100Equivalent": 67710.96513390601,
          "capitalCostB": 3.5609080000000004
        },
        {
          "date": "2025-02-04",
          "status": "Building 3 is operational, based on the building looking complete and the carpark to the south being full. Three more backup generators added to the Building 1 and 2 area, with a lot more construction equipment again (but this could be a laydown area for Richmond 2). Building 4 has cooling and backup generators fully installed. Building 5 has cooling installed, and backup generators partly installed.",
          "buildingsOperational": 3.0,
          "itPowerMw": 142.0,
          "h100Equivalent": 125821.1217786761,
          "capitalCostB": 5.379244
        },
        {
          "date": "2025-06-03",
          "status": "Building 4 is operational, based on a complete building and full carpark in a [Google Earth image](https://earth.google.com/web/@37.48350155,-77.25010039,60.24751599a,83.68032361d,30.00094375y,3.66969189h,0t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ). Building 5 does not seem quite operational given the empty carpark and construction activity at the perimeter.",
          "buildingsOperational": 4.0,
          "itPowerMw": 190.0,
          "h100Equivalent": 183931.27842344617,
          "capitalCostB": 7.19758
        },
        {
          "date": "2025-11-19",
          "status": "Building 5 is operational, based on a complete building and full carpark in a [Google Earth image](https://earth.google.com/web/@37.48747566,-77.2485616,47.03705985a,2549.72172121d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDI1LTExLTE5GAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE). Construction equipment around Building 1 and 2 has cleared up again.",
          "buildingsOperational": 5.0,
          "itPowerMw": 238.0,
          "h100Equivalent": 242546.7407781708,
          "capitalCostB": 9.015915999999999
        },
        {
          "date": "2025-12-31",
          "status": "No changes to the site since November 2025.",
          "buildingsOperational": 5.0,
          "itPowerMw": 238.0,
          "h100Equivalent": 242546.7407781708,
          "capitalCostB": 9.015915999999999
        },
        {
          "date": "2026-02-13",
          "status": "No changes to the site since December 2025.",
          "buildingsOperational": 5.0,
          "itPowerMw": 238.0,
          "h100Equivalent": 242546.7407781708,
          "capitalCostB": 9.015915999999999
        }
      ]
    },
    {
      "name": "Meta Rosemount",
      "slug": "meta-rosemount",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "1772-2396 145th St, Rosemount, MN 55068, USA",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 178.0,
      "currentH100Equivalent": 215765.5381505811,
      "currentCapitalCostB": 6.742996,
      "timeline": [
        {
          "date": "2024-05-30",
          "status": "Land is cleared.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-21",
          "status": "Both buildings and their cooling infrastructure look complete, but the site probably isn't commissioned (tested) yet, and few cars are parked to the right of Building 1. We give another 3 months before it's operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-19",
          "status": "Building 1 and 2 are operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 178.0,
          "h100Equivalent": 215765.5381505811,
          "capitalCostB": 6.742996
        }
      ]
    },
    {
      "name": "Amazon Madison Mega Site",
      "slug": "amazon-madison-mega-site",
      "owner": "Amazon",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "Amazon Data Services Inc, Madison Mega Site Nissan Parkway and Highway 22 Canton, Mississippi Madison County",
      "project": "Project Rainier #speculative",
      "currentChipTypes": [
        "Trainium2"
      ],
      "allChipTypes": [
        "Trainium2"
      ],
      "currentPowerMw": 284.0,
      "currentH100Equivalent": 214348.14354550533,
      "currentCapitalCostB": 10.758488,
      "timeline": [
        {
          "date": "2023-10-02",
          "status": "Land clearing begins",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-03-11",
          "status": "Generators and chillers still being installed on buildings 1-5.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-23",
          "status": "Buildings 1-5 are operational, based on roofs being completed 5 months ago and generators being installed by 2025-04-10.",
          "buildingsOperational": 5.0,
          "itPowerMw": 284.0,
          "h100Equivalent": 214348.14354550533,
          "capitalCostB": 10.758488
        },
        {
          "date": "2025-10-04",
          "status": "Confirmation that five buildings are fully equipped with cooling and backup generators.",
          "buildingsOperational": 5.0,
          "itPowerMw": 284.0,
          "h100Equivalent": 214348.14354550533,
          "capitalCostB": 10.758488
        },
        {
          "date": "2026-06-04",
          "status": "Buildings 6 and 7 roof completed. Building 8 roof nearly completed. Building 9 roof half way up. No new operational buildings.",
          "buildingsOperational": 5.0,
          "itPowerMw": 284.0,
          "h100Equivalent": 214348.14354550533,
          "capitalCostB": 10.758488
        },
        {
          "date": "2027-03-01",
          "status": "Buildings 6 and 7 operational, estimated from roofs having been completed 9 months ago (similar timeline to AWS buildings at New Carlisle in 2025).",
          "buildingsOperational": 7.0,
          "itPowerMw": 284.0,
          "h100Equivalent": 300087.4009637075,
          "capitalCostB": 10.758488
        },
        {
          "date": "2028-03-15",
          "status": "Buildings 8-12 are operational. In June of 2026 only a faint outline of buildings 10,11 and 12 is visible, estimating construction completion to be the end of 2027, alligning with [expected completion by 2027](https://www.datacenterdynamics.com/en/news/aws-confirmed-as-company-behind-10bn-mississippi-data-center-development/). This final estimates adds three months to that for server installation.",
          "buildingsOperational": 12.0,
          "itPowerMw": 683.0,
          "h100Equivalent": 514435.54450921173,
          "capitalCostB": 25.873406000000003
        }
      ]
    },
    {
      "name": "Microsoft Goodyear",
      "slug": "microsoft-goodyear",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "likely"
        },
        {
          "name": "Microsoft",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "14250 W Broadway Rd, Goodyear, AZ 85338",
      "project": "",
      "currentChipTypes": [
        "H100",
        "B200"
      ],
      "allChipTypes": [
        "H100",
        "B200"
      ],
      "currentPowerMw": 202.0,
      "currentH100Equivalent": 205154.11824153614,
      "currentCapitalCostB": 7.652164000000001,
      "timeline": [
        {
          "date": "2021-06-21",
          "status": "Land clearing begins for Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-04-24",
          "status": "Building 1 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
          "buildingsOperational": 1.0,
          "itPowerMw": 40.0,
          "h100Equivalent": 29156.13946437595,
          "capitalCostB": 1.51528
        },
        {
          "date": "2025-01-16",
          "status": "Building 2 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
          "buildingsOperational": 2.0,
          "itPowerMw": 81.0,
          "h100Equivalent": 58110.15664477008,
          "capitalCostB": 3.068442
        },
        {
          "date": "2025-09-01",
          "status": "Building 3 and 4 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
          "buildingsOperational": 4.0,
          "itPowerMw": 202.0,
          "h100Equivalent": 205154.11824153614,
          "capitalCostB": 7.652164000000001
        },
        {
          "date": "2025-11-12",
          "status": "Confirmation that Building 3 and 4 look complete.",
          "buildingsOperational": 4.0,
          "itPowerMw": 202.0,
          "h100Equivalent": 205154.11824153614,
          "capitalCostB": 7.652164000000001
        },
        {
          "date": "2026-04-27",
          "status": "Foundations appear to be underway for Building 5 and 6, just north of Building 4.",
          "buildingsOperational": 4.0,
          "itPowerMw": 202.0,
          "h100Equivalent": 205154.11824153614,
          "capitalCostB": 7.652164000000001
        }
      ]
    },
    {
      "name": "Meta Jeffersonville",
      "slug": "meta-jeffersonville",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "500 8th St, Jeffersonville, IN 47130, USA",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 178.0,
      "currentH100Equivalent": 203132.89540171804,
      "currentCapitalCostB": 6.742996,
      "timeline": [
        {
          "date": "2024-02-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-06",
          "status": "Building 1 and 2 shell and cooling look complete, but there's still construction activity. We give it another 3 months to operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-04",
          "status": "Building 1 and 2 are operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 178.0,
          "h100Equivalent": 203132.89540171804,
          "capitalCostB": 6.742996
        }
      ]
    },
    {
      "name": "Google The Dalles",
      "slug": "google-the-dalles",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "3500 River Rd, The Dalles, OR",
      "project": "",
      "currentChipTypes": [
        "TPU v6e",
        "TPU v5p",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v6e",
        "TPU v5p",
        "TPU v7"
      ],
      "currentPowerMw": 154.0,
      "currentH100Equivalent": 201616.97827185446,
      "currentCapitalCostB": 5.8338280000000005,
      "timeline": [
        {
          "date": "2023-05-21",
          "status": "First signs of construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-03-07",
          "status": "Building 1 is estimated to be operational, based on all external equipment being installed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 77.0,
          "h100Equivalent": 93986.86205154119,
          "capitalCostB": 2.9169140000000002
        },
        {
          "date": "2026-04-29",
          "status": "Building 2 is estimated to be operational, based on all external equipment being installed, and ordinary cars parked by the building.",
          "buildingsOperational": 2.0,
          "itPowerMw": 154.0,
          "h100Equivalent": 201616.97827185446,
          "capitalCostB": 5.8338280000000005
        }
      ]
    },
    {
      "name": "Google Midlothian",
      "slug": "google-midlothian",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "3250 Railport Parkway, Midlothian, TX 76065",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 103.0,
      "currentH100Equivalent": 191005.5583628095,
      "currentCapitalCostB": 3.901846,
      "timeline": [
        {
          "date": "2023-11-28",
          "status": "Visible land clearing around the area for Building 1",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-10-01",
          "status": "Building 1 roof is complete.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-19",
          "status": "Building 1 is probably mostly operational despite some cooling towers yet to be installed. In the original building permit Google only expected to build 6 new cooling towers, but they've extended the row further. This might be to support new chips with denser power configurations. Across the road, you can see the beginnings of land development for what is likely an expansion of the site, but we don't have any details on it yet.",
          "buildingsOperational": 1.0,
          "itPowerMw": 69.0,
          "h100Equivalent": 121273.3703890854,
          "capitalCostB": 2.613858
        },
        {
          "date": "2026-07-01",
          "status": "Estimated full completion of the expanded row of cooling towers and backup generators.",
          "buildingsOperational": 1.0,
          "itPowerMw": 103.0,
          "h100Equivalent": 191005.5583628095,
          "capitalCostB": 3.901846
        }
      ]
    },
    {
      "name": "QTS Richmond 2",
      "slug": "qts-richmond-2",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "6030–6070 Technology Blvd, Sandston, VA 23150",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 180.0,
      "currentH100Equivalent": 182920.66700353715,
      "currentCapitalCostB": 6.818759999999999,
      "timeline": [
        {
          "date": "2022-04-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-01-29",
          "status": "Building 1 and 2 look complete but we don't think they are operational, as the substation is still under construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-06-23",
          "status": "Still not many cars parked at Building 1 and 2, and the east substation looks very close to completion, based on a [Google Earth image](https://earth.google.com/web/@37.48655608,-77.24244153,55.96289131a,2859.52501034d,30.00094375y,0h,0.5917603t,0r/data=ChYqEAgBEgoyMDI0LTA2LTIzGAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-02-04",
          "status": "Building 1 and 2 are operational, based on the east substation looking complete and the carparks being more full. Building 3 has cooling and generators mostly installed. Building 4 roof is partly completed.",
          "buildingsOperational": 2.0,
          "itPowerMw": 72.0,
          "h100Equivalent": 52046.48812531582,
          "capitalCostB": 2.7275039999999997
        },
        {
          "date": "2025-11-19",
          "status": "The west substation looks complete, based on a [Google Earth image](https://earth.google.com/web/@37.48673632,-77.24119214,61.15398527a,3616.77426559d,30.00094375y,0.00000001h,0.59183057t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ). This image also shows one corner of Building 5 that still has construction work, so it's probably not operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 72.0,
          "h100Equivalent": 52046.48812531582,
          "capitalCostB": 2.7275039999999997
        },
        {
          "date": "2025-12-31",
          "status": "Building 3 and 4 are operational, based on the substation being completed earlier, the buildings looking complete, and carparks being moderately full. Building 5 still has construction work.",
          "buildingsOperational": 4.0,
          "itPowerMw": 144.0,
          "h100Equivalent": 138959.0702374937,
          "capitalCostB": 5.455007999999999
        },
        {
          "date": "2026-02-13",
          "status": "Building 5 still has construction work at the perimeter, but given how close it looks to completion, we estimate it's only about 3 months away from operational.",
          "buildingsOperational": 4.0,
          "itPowerMw": 144.0,
          "h100Equivalent": 138959.0702374937,
          "capitalCostB": 5.455007999999999
        },
        {
          "date": "2026-05-14",
          "status": "Building 5 is estimated to be operational, based on the previous entry.",
          "buildingsOperational": 5.0,
          "itPowerMw": 180.0,
          "h100Equivalent": 182920.66700353715,
          "capitalCostB": 6.818759999999999
        }
      ]
    },
    {
      "name": "QTS Richmond 3",
      "slug": "qts-richmond-3",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "3525–3543 Portugee Rd, Sandston, VA 23150",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 144.0,
      "currentH100Equivalent": 174835.77564426477,
      "currentCapitalCostB": 5.455007999999999,
      "timeline": [
        {
          "date": "2024-04-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-02-04",
          "status": "Building 1 shell is mostly complete, with some chillers installed on the roof. Building 2 shell is under construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-11-19",
          "status": "The substation is still under construction, based on a [Google Earth image](https://earth.google.com/web/@37.48033002,-77.25002949,65.53442036a,2152.9927926d,30.00094375y,-0.00000001h,0.59169466t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ), so we don't think any buildings are operational yet.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-31",
          "status": "The substation looks complete, but we expect Building 1 still needs commissioning before it is fully operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-13",
          "status": "Building 1 is operational, based on the substation being completed earlier and cars in the carpark. Building 2 and 3 are not operational, based on minor construction work at the perimeter and no cars in the carpark, but we expect they will be operational within 3 months. Building 4 has complete chillers and backup generators, while Building 5 has chillers but only a few backup generators - roughly the state of Building 1 on 2025-02-04.",
          "buildingsOperational": 1.0,
          "itPowerMw": 48.0,
          "h100Equivalent": 58110.15664477008,
          "capitalCostB": 1.818336
        },
        {
          "date": "2026-05-14",
          "status": "Building 2 and 3 are operational, based on the previous entry.",
          "buildingsOperational": 3.0,
          "itPowerMw": 144.0,
          "h100Equivalent": 174835.77564426477,
          "capitalCostB": 5.455007999999999
        },
        {
          "date": "2027-02-13",
          "status": "Building 4 and 5 are operational, based on Building 5 being roughly 1 year behind Building 1 in satellite imagery.",
          "buildingsOperational": 5.0,
          "itPowerMw": 240.0,
          "h100Equivalent": 291056.08893380495,
          "capitalCostB": 9.09168
        }
      ]
    },
    {
      "name": "Meta Montgomery",
      "slug": "meta-montgomery",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "Co Rd 42, Montgomery, AL 36105, USA",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 153.0,
      "currentH100Equivalent": 174517.43304699342,
      "currentCapitalCostB": 5.795946,
      "timeline": [
        {
          "date": "2025-03-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-07-04",
          "status": "Building 1 and 2 under construction, with all chillers visible.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-20",
          "status": "Buildings 1 and 2 are nearly complete, but there's still some equipment strewn around the site and few cars in the front carpark, so we expect 3 more months needed for commissioning and server installation. Building 3 has a half-finished roof and Building 4 shell is beginning construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-18",
          "status": "Building 1 and 2 are operational (estimate).",
          "buildingsOperational": 2.0,
          "itPowerMw": 153.0,
          "h100Equivalent": 174517.43304699342,
          "capitalCostB": 5.795946
        },
        {
          "date": "2027-01-02",
          "status": "Buildings 5 and 6 are operational (estimate). Based on the tent buildings at Meta Prometheus taking about 11 months from starting the tent structure to estimated operation.",
          "buildingsOperational": 4.0,
          "itPowerMw": 204.0,
          "h100Equivalent": 232968.6710459828,
          "capitalCostB": 7.727927999999999
        },
        {
          "date": "2027-02-23",
          "status": "Buildings 3 and 4 are operational (estimate). In September 2025, Building 1 and 2 appeared to be in a similar state to Building 3 and 4 in May 2026. Based on that, we apply an 8-month delay to the Building 1 and 2 operational date to get the Building 3 and 4 operational date.",
          "buildingsOperational": 6.0,
          "itPowerMw": 358.0,
          "h100Equivalent": 407486.10409297625,
          "capitalCostB": 13.561755999999999
        }
      ]
    },
    {
      "name": "Meta Kuna",
      "slug": "meta-kuna",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "601 Kuna Mora Rd, Kuna ID 83634",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 152.0,
      "currentH100Equivalent": 173319.85851440122,
      "currentCapitalCostB": 5.758064,
      "timeline": [
        {
          "date": "2022-10-03",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-15",
          "status": "Building 1 and 2 look complete from outside, with all electrical and cooling equipment installed. Construction has started on 2 smaller buldings to the north. Meta announced the arrival of the first server rack the following week.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-01",
          "status": "Building 1 and 2 are operational. The 2nd phase of an offsetting solar array goes online on May 31, 2026. Idaho Public Utilities Comission's approval for this start date notes that \"[Meta]’s load is expected to increase so much that it will suffer a capacity deficit in June 2026 if served only by Pleasant Valley Solar 1.1,” A redacted table in the staff comments document suggests the data center's load will continue to increase through August, when it presumably reaches the maximum capacity of both buildings.",
          "buildingsOperational": 2.0,
          "itPowerMw": 152.0,
          "h100Equivalent": 173319.85851440122,
          "capitalCostB": 5.758064
        }
      ]
    },
    {
      "name": "Meta Temple",
      "slug": "meta-temple",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "2310 Eberhardt Rd, Temple, TX 76504",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 152.0,
      "currentH100Equivalent": 173247.6719844078,
      "currentCapitalCostB": 5.758064,
      "timeline": [
        {
          "date": "2022-04-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-02-05",
          "status": "A traditional H-shaped Meta data center is partially built.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-04-01",
          "status": "The traditional Meta data center has been demolished mid-construction, in favor of Meta's new AI-optimized design.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-11-15",
          "status": "Building 1 and 2 look complete from outside, with all electrical and cooling equipment installed. Space is cleared for Building 3.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-09",
          "status": "Building 1 and 2 are operational. Activity related to the air quality permit (namely, emergency diesel generators) was reported to have started as of 2025-12-09. This is our best estimate, but note that the planned completion date in this [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2022017728) is 2026-03-01.",
          "buildingsOperational": 2.0,
          "itPowerMw": 152.0,
          "h100Equivalent": 173247.6719844078,
          "capitalCostB": 5.758064
        },
        {
          "date": "2026-09-30",
          "status": "Building 3 is operational. Based on the stated completion date in this [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008019)",
          "buildingsOperational": 3.0,
          "itPowerMw": 178.0,
          "h100Equivalent": 202472.98777125112,
          "capitalCostB": 6.742996
        }
      ]
    },
    {
      "name": "Meta Cheyenne",
      "slug": "meta-cheyenne",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "Cheyenne, WY 82007, USA",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 152.0,
      "currentH100Equivalent": 172814.5528044467,
      "currentCapitalCostB": 5.758064,
      "timeline": [
        {
          "date": "2024-05-15",
          "status": "Ground is being cleared.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-01-30",
          "status": "Structure for Building 1 and 2 under construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-22",
          "status": "Building 1 shell and cooling looks complete, Building 2 roof almost complete.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-07-25",
          "status": "Both buildings estimated to be operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 152.0,
          "h100Equivalent": 172814.5528044467,
          "capitalCostB": 5.758064
        },
        {
          "date": "2027-02-15",
          "status": "Buildings 3 and 4 are similar in style and size to the ones seen at the Prometheus site, we estimate their operability based on that timeline.",
          "buildingsOperational": 4.0,
          "itPowerMw": 220.0,
          "h100Equivalent": 251136.93784739767,
          "capitalCostB": 8.33404
        }
      ]
    },
    {
      "name": "Amazon Ridgeland",
      "slug": "amazon-ridgeland",
      "owner": "Amazon",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "1626 County Line Road Ridgeland, Mississippi",
      "project": "Project Rainier #speculative",
      "currentChipTypes": [
        "Trainium2"
      ],
      "allChipTypes": [
        "Trainium2",
        "Trainium3"
      ],
      "currentPowerMw": 228.0,
      "currentH100Equivalent": 171298.6356745831,
      "currentCapitalCostB": 8.637096,
      "timeline": [
        {
          "date": "2024-02-24",
          "status": "Land clearing begins",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-04",
          "status": "Roof complete on Buildings 3",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-15",
          "status": "Buildings 1-4 are operational, based on the buildings shells and backup generators and most of the landscaping looking complete. Building 5 roof is complete but still lacks cooling equipment.",
          "buildingsOperational": 4.0,
          "itPowerMw": 228.0,
          "h100Equivalent": 171298.6356745831,
          "capitalCostB": 8.637096
        },
        {
          "date": "2027-02-09",
          "status": "Building 5 is operational (estimate).",
          "buildingsOperational": 5.0,
          "itPowerMw": 284.0,
          "h100Equivalent": 214249.62102071755,
          "capitalCostB": 10.758488
        },
        {
          "date": "2028-09-29",
          "status": "Buildings 6-14 are operational (estimate). Buildings 1-4 took an estimated 2.25 years on this site. We assume Buildings 6-14 get underway by July 2026, and take the same time as Buildings 1-4. This is later than the [expected completion by 2027](https://www.datacenterdynamics.com/en/news/aws-confirmed-as-company-behind-10bn-mississippi-data-center-development/).",
          "buildingsOperational": 14.0,
          "itPowerMw": 840.0,
          "h100Equivalent": 788276.907529055,
          "capitalCostB": 31.820879999999995
        }
      ]
    },
    {
      "name": "Meta Aiken",
      "slug": "meta-aiken",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "7601 State Hwy 105, Trenton, SC 29847, USA",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 142.0,
      "currentH100Equivalent": 161697.82718544718,
      "currentCapitalCostB": 5.379244,
      "timeline": [
        {
          "date": "2024-05-30",
          "status": "Land clearing begins",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-08",
          "status": "Buildings 1 and 2 are nearly complete, but there's still some equipment strewn around the site. We expect 3 more months needed for commissioning and server installation.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-07-15",
          "status": "Building 1 and 2 are operational (estimate).",
          "buildingsOperational": 2.0,
          "itPowerMw": 142.0,
          "h100Equivalent": 161697.82718544718,
          "capitalCostB": 5.379244
        }
      ]
    },
    {
      "name": "Coreweave Helios",
      "slug": "coreweave-helios",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "984 County Road 112, Afton, TX 79220",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 132.0,
      "currentH100Equivalent": 159551.768236855,
      "currentCapitalCostB": 5.000424000000001,
      "timeline": [
        {
          "date": "2025-05-31",
          "status": "The former [crypto mining](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Commitment-with-CoreWeave-to-Host-Additional-Artificial-Intelligence-and-High-Performance-Computing-Infrastructure-at-Helios-Data-Center-Campus/default.aspx) Helios site begins expanding, with land cleared for additional buildings.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-08-27",
          "status": "Backup generator pads and steel framing for chillers are visible, similar to the [3D renderings](https://www.galaxy.com/data-centers).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-04",
          "status": "Building 1 appears substantially complete. The main white-roofed data hall is visible with exterior mechanical/electrical equipment rows installed on both sides, and adjacent generator/equipment pads plus laydown yards are active. A large graded pad north of Building 1 suggests preparation for the next phase/building. No clear satellite evidence that the AI/HPC facility is operational yet.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-30",
          "status": "Building 1 operational at full capacity. This corresponds to \"Phase I\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be operational by the end of the first half of 2026.",
          "buildingsOperational": 1.0,
          "itPowerMw": 132.0,
          "h100Equivalent": 159551.768236855,
          "capitalCostB": 5.000424000000001
        },
        {
          "date": "2028-01-01",
          "status": "Building 2 and 3 are operational at full capacity. This corresponds to \"Phase II\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be delivered \"throughout 2027\". We assume it takes until the end of 2027 to reach full capacity.",
          "buildingsOperational": 3.0,
          "itPowerMw": 396.0,
          "h100Equivalent": 478655.30471056444,
          "capitalCostB": 15.001272
        },
        {
          "date": "2029-01-01",
          "status": "Building 4 operational at full capacity. This corresponds to \"Phase III\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be delivered \"starting in 2028\". We assume it takes until the end of 2028 to reach full capacity.",
          "buildingsOperational": 4.0,
          "itPowerMw": 528.0,
          "h100Equivalent": 638207.072947418,
          "capitalCostB": 20.001696000000003
        }
      ]
    },
    {
      "name": "Google Arcola",
      "slug": "google-arcola",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "42575 Arcola Blvd, Sterling, VA 20166",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 77.0,
      "currentH100Equivalent": 157150.07579585648,
      "currentCapitalCostB": 2.9169140000000002,
      "timeline": [
        {
          "date": "2024-10-01",
          "status": "Building 1 foundation started",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-08",
          "status": "Building 1 roof complete, cooling towers in progress.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-09",
          "status": "Building 1 appears almost complete, with minimal construction activity.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-16",
          "status": "Building 1 is operational, based off of colored motion artifacts from cooling towers and direct visual verification.",
          "buildingsOperational": 1.0,
          "itPowerMw": 77.0,
          "h100Equivalent": 157150.07579585648,
          "capitalCostB": 2.9169140000000002
        }
      ]
    },
    {
      "name": "Microsoft Project Osmium",
      "slug": "microsoft-project-osmium",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "5855 SW Kerry St, Cumming, IA 50061",
      "project": "",
      "currentChipTypes": [
        "A100",
        "H100",
        "B200"
      ],
      "allChipTypes": [
        "A100",
        "H100",
        "B200"
      ],
      "currentPowerMw": 190.0,
      "currentH100Equivalent": 155634.15866599293,
      "currentCapitalCostB": 7.19758,
      "timeline": [
        {
          "date": "2018-12-18",
          "status": "Land clearing begins on the north part of the site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2021-01-01",
          "status": "Building 1 and 1st building on the site are operational. Foundation work begins on Building 2",
          "buildingsOperational": 1.0,
          "itPowerMw": 48.0,
          "h100Equivalent": 7882.769075290551,
          "capitalCostB": 1.818336
        },
        {
          "date": "2023-06-30",
          "status": "Building 2 is operational. Estimated based on Microsoft H100 count 2023",
          "buildingsOperational": 2.0,
          "itPowerMw": 95.0,
          "h100Equivalent": 40576.048509348155,
          "capitalCostB": 3.59879
        },
        {
          "date": "2025-03-01",
          "status": "Building 3-4 operational, no visible construction.",
          "buildingsOperational": 4.0,
          "itPowerMw": 190.0,
          "h100Equivalent": 155634.15866599293,
          "capitalCostB": 7.19758
        },
        {
          "date": "2025-10-08",
          "status": "Site already complete.",
          "buildingsOperational": 4.0,
          "itPowerMw": 190.0,
          "h100Equivalent": 155634.15866599293,
          "capitalCostB": 7.19758
        },
        {
          "date": "2026-06-16",
          "status": "No notable changes since October.",
          "buildingsOperational": 4.0,
          "itPowerMw": 190.0,
          "h100Equivalent": 155634.15866599293,
          "capitalCostB": 7.19758
        }
      ]
    },
    {
      "name": "Google Storey County",
      "slug": "google-storey-county",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v6e"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v6e"
      ],
      "currentPowerMw": 161.0,
      "currentH100Equivalent": 153612.93582617483,
      "currentCapitalCostB": 6.0990020000000005,
      "timeline": [
        {
          "date": "2023-08-30",
          "status": "Building 1, which was first operational in 2021, has increased power capacity by about 75%. This is based on the expansion of the dry cooling array from 4 to 7 columns (seen on [Google Earth](https://earth.google.com/web/@39.4948785,-119.43174359,1568.8659293a,562.69639351d,35y,-0h,0t,0r/)). Its backup generators also grew from 18 to 33, an 83% increase. Around this time (2023 Q3) the quarterly PUE of the campus is 1.24, down from the initial 1.29 in 2022 Q3. Since no other buildings have been added, these changes indicate an increase in power density, which may entail a new generation of hardware getting installed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 81.0,
          "h100Equivalent": 40778.17079332996,
          "capitalCostB": 3.068442
        },
        {
          "date": "2025-03-11",
          "status": "Building 2 now has generators in place, but there is still a crane and construction work present.",
          "buildingsOperational": 1.0,
          "itPowerMw": 81.0,
          "h100Equivalent": 40778.17079332996,
          "capitalCostB": 3.068442
        },
        {
          "date": "2025-06-30",
          "status": "Building 2 is operational. Based on a [Google Earth image](https://earth.google.com/web/@39.49733738,-119.43113543,1552.05877612a,1467.7067385d,35y,0h,0t,0r/) showing complete building shell, mechanical equipment and generators, plus cars parked at the front.",
          "buildingsOperational": 2.0,
          "itPowerMw": 161.0,
          "h100Equivalent": 153612.93582617483,
          "capitalCostB": 6.0990020000000005
        },
        {
          "date": "2025-09-28",
          "status": "Building 3 foundation is underway. Building 2 exterior looks totally clean/landscaped.",
          "buildingsOperational": 2.0,
          "itPowerMw": 161.0,
          "h100Equivalent": 153612.93582617483,
          "capitalCostB": 6.0990020000000005
        },
        {
          "date": "2026-04-13",
          "status": "Building 3 has a partially complete shell, electrical and mechanical equipment. Building 4 foundation is underway.",
          "buildingsOperational": 2.0,
          "itPowerMw": 161.0,
          "h100Equivalent": 153612.93582617483,
          "capitalCostB": 6.0990020000000005
        },
        {
          "date": "2027-06-30",
          "status": "Building 3 is estimated to be operational. We estimate the operational date by analogy to the time that Building 1 took to go from a foundation to being operational. The power capacity is based on the number of generators reported in an air quality permit [application](https://ndep-onbase.nv.gov/api/Document/AeFo%C3%89pjclbkomJ7CWpPryLOjA6FQT9HFrkSuMWbMXTpKCzSR%C3%81W1f8zzFhGhik1iZCcNSpuTRRqNXD1inrrpBxtA%3D/) (p.92-93). The dry cooler array is more than double the size of the Building 1 array, which suggests an even larger power capacity than we estimate, but we believe the generator-based estimate is more reliable here.",
          "buildingsOperational": 3.0,
          "itPowerMw": 300.0,
          "h100Equivalent": 651844.365841334,
          "capitalCostB": 11.3646
        }
      ]
    },
    {
      "name": "Meta Eagle Mountain",
      "slug": "meta-eagle-mountain",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "1275 N Community Cir, Eagle Mountain, UT 84005",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 133.0,
      "currentH100Equivalent": 151354.21930267813,
      "currentCapitalCostB": 5.038306,
      "timeline": [
        {
          "date": "2023-10-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-08",
          "status": "We believe Buildings 1 and 2 are still undergoing testing due to construction equipment and unfinished land surrounding the data center sites, as well as color motion artifacts on a small number of the cooling fans.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-07",
          "status": "Buildings 1 and 2 both estimated to be operational 90 days after testing was underway in September.",
          "buildingsOperational": 2.0,
          "itPowerMw": 133.0,
          "h100Equivalent": 151354.21930267813,
          "capitalCostB": 5.038306
        },
        {
          "date": "2026-05-02",
          "status": "Satellite image shows strong evidence that Buildings 1 and 2 are operational: colored motion artifacts on many cooling fans, plus cars parked at the building entrances.",
          "buildingsOperational": 2.0,
          "itPowerMw": 133.0,
          "h100Equivalent": 151354.21930267813,
          "capitalCostB": 5.038306
        }
      ]
    },
    {
      "name": "Google Lancaster",
      "slug": "google-lancaster",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "105 Whiley Rd, Lancaster, OH 43130",
      "project": "",
      "currentChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v7",
        "TPU v6e"
      ],
      "allChipTypes": [
        "TPU v5e",
        "TPU v5p",
        "TPU v7",
        "TPU v6e"
      ],
      "currentPowerMw": 137.0,
      "currentH100Equivalent": 130368.8731682668,
      "currentCapitalCostB": 5.189834,
      "timeline": [
        {
          "date": "2021-10-01",
          "status": "Land clearing in progress for the site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-01-01",
          "status": "Building 1 operational. This is estimated based on construction progress in [October 2023](https://earth.google.com/web/@39.72490515,-82.68845499,280.4138206a,1128.806013d,35y,-0h,0t,0r/data=CnUaXRJXCiUweDg4NDc4OWI3MDRhZGE1MWQ6MHg0Y2Q1MjE2ZGM0YTQ0YTc5GSZeVEH73ENAISDkBo2qq1TAKhwxMDQgV2hpbGV5IFJkLCBMYW5jYXN0ZXIsIE9IGAIgASoQCAESCjIwMjMtMDUtMTAYAUICCAFCAggASg0I____________ARAA). This also corresponds to a [2023 article](https://ohiocapitaljournal.com/2023/08/29/google-announces-plans-to-invest-1-7-billion-in-a-trio-of-central-ohio-data-centers/) where a Google spokesperson says that the \"the Lancaster data center will open later this year\".",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 34562.91056088934,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2025-09-11",
          "status": "Building 2 is close to completion. Structurally it is already complete, but there is still some equipment strewn around the building that suggests commissioning is ongoing.",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 34562.91056088934,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2025-10-31",
          "status": "Building 2 operational. This is supported by the state of Building 2 a month prior, which is entirely complete outside of some equipment that was removed later on.",
          "buildingsOperational": 2.0,
          "itPowerMw": 137.0,
          "h100Equivalent": 130368.8731682668,
          "capitalCostB": 5.189834
        },
        {
          "date": "2026-03-12",
          "status": "At this point, Building 1 and 2 have since already been operational. Additionally, there is visible steam showing clear evidence of operational for both before this date.",
          "buildingsOperational": 2.0,
          "itPowerMw": 137.0,
          "h100Equivalent": 130368.8731682668,
          "capitalCostB": 5.189834
        }
      ]
    },
    {
      "name": "Google Mesa",
      "slug": "google-mesa",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "",
      "project": "",
      "currentChipTypes": [
        "TPU v6e"
      ],
      "allChipTypes": [
        "TPU v6e"
      ],
      "currentPowerMw": 90.0,
      "currentH100Equivalent": 125821.1217786761,
      "currentCapitalCostB": 3.4093799999999996,
      "timeline": [
        {
          "date": "2023-07-01",
          "status": "Land clearing begins for the entire site.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-07-01",
          "status": "Building 1 is operational. This is based on the state of construction on 2025-03-02 as seen on [Google Earth](https://earth.google.com/web/@33.35450568,-111.67805903,407.02398359a,2119.1496037d,35y,-0h,0t,0r/data=ChYqEAgBEgoyMDI1LTAzLTAyGAFCAggBQgIIAEoNCP___________wEQAA), where building shell and external components seems to have been completed, but there is still a lot of construction equipment present. That equipment appears to have been cleared up by this date, 4 months later, with the 2025-09-07 satellite imagery providing an upper bound. Construction has begun on the Building 2 roof, with work beginning on the areas for cooling and generators as well.",
          "buildingsOperational": 1.0,
          "itPowerMw": 90.0,
          "h100Equivalent": 125821.1217786761,
          "capitalCostB": 3.4093799999999996
        },
        {
          "date": "2025-09-07",
          "status": "Building 2 roof is mostly completed. Building 2's backup generators are almost complete, and cooling is a little more than halfway complete. The Building 2 substation is also under construction.",
          "buildingsOperational": 1.0,
          "itPowerMw": 90.0,
          "h100Equivalent": 125821.1217786761,
          "capitalCostB": 3.4093799999999996
        },
        {
          "date": "2026-05-15",
          "status": "Building 2 is close to being operational. There is only construction left on the backup generators, which are almost complete. Some equipment is also strewn around the building, especially near the air-cooled chillers. Preparation seems to have begun for Building 3 at the site.",
          "buildingsOperational": 1.0,
          "itPowerMw": 90.0,
          "h100Equivalent": 125821.1217786761,
          "capitalCostB": 3.4093799999999996
        },
        {
          "date": "2026-08-15",
          "status": "Building 2 is operational. This is estimated based on the close-to-complete construction status from May 2026.",
          "buildingsOperational": 2.0,
          "itPowerMw": 183.0,
          "h100Equivalent": 343102.57705912075,
          "capitalCostB": 6.932405999999999
        }
      ]
    },
    {
      "name": "Google Waltham Cross",
      "slug": "google-waltham-cross",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United Kingdom",
      "address": "Land at Maxwell's Farm West, Great Cambridge Road, Cheshunt, EN8 8XH",
      "project": "",
      "currentChipTypes": [
        "TPU v6e",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v6e",
        "TPU v7"
      ],
      "currentPowerMw": 88.0,
      "currentH100Equivalent": 123799.89893885801,
      "currentCapitalCostB": 3.3336159999999997,
      "timeline": [
        {
          "date": "2024-01-01",
          "status": "Land clearing begins (Sentinel-2 imagery).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-01",
          "status": "Building complete and operational; full buildout reached. Sentinel-2 imagery shows the building finished with components installed and cars in the car park. Confirmed by Google's official blog post announcing the Waltham Cross data centre opening (https://blog.google/company-news/inside-google/around-the-globe/google-europe/united-kingdom/waltham-cross-data-centre/).",
          "buildingsOperational": 1.0,
          "itPowerMw": 88.0,
          "h100Equivalent": 123799.89893885801,
          "capitalCostB": 3.3336159999999997
        },
        {
          "date": "2026-04-23",
          "status": "Full buildout reconfirmed via high-resolution Pléiades-Neo satellite image; no capacity change since September 2025.",
          "buildingsOperational": 1.0,
          "itPowerMw": 88.0,
          "h100Equivalent": 123799.89893885801,
          "capitalCostB": 3.3336159999999997
        }
      ]
    },
    {
      "name": "VNET Bayin Ulanqab",
      "slug": "vnet-bayin-ulanqab",
      "owner": "VNET",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "ByteDance",
          "confidence": "speculative"
        }
      ],
      "country": "China",
      "address": "Bayin, Ulanqab, China",
      "project": "10 GW Hyperscale 2.0 #confident",
      "currentChipTypes": [
        "Ascend 910C"
      ],
      "allChipTypes": [
        "Ascend 910C"
      ],
      "currentPowerMw": 221.0,
      "currentH100Equivalent": 122789.28751894896,
      "currentCapitalCostB": 8.371922,
      "timeline": [
        {
          "date": "2024-03-15",
          "status": "Land clearing begins late March, as can be seen in satellite images (eastern part: buildings 1 & 2). VNET officially [announces](https://web.archive.org/web/20250620154431/https://www.vnet.com/portal/article/index/cid/14/id/876.html) its signing ceremony with the Ulanqab municipal government and Shandong Hi-Speed Holdings.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-02-05",
          "status": "Satellite imagery shows five buildings (1, 2, 3, 4, 5) under construction. Chillers are in place, but no roof is complete for any building.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-07-01",
          "status": "Building 1 is operational, based on a 3-month fit-out period after structural completion in April, as can be seen from satellite imagery.",
          "buildingsOperational": 1.0,
          "itPowerMw": 38.0,
          "h100Equivalent": 20970.186963112683,
          "capitalCostB": 1.439516
        },
        {
          "date": "2025-08-01",
          "status": "Satellite imagery shows that in total nine buildings have started construction, with building 1 being the only one operational. Buildings 2 and 5 are structurally complete, and the final roofs for buildings 3 and 4 have begun.",
          "buildingsOperational": 1.0,
          "itPowerMw": 38.0,
          "h100Equivalent": 20970.186963112683,
          "capitalCostB": 1.439516
        },
        {
          "date": "2025-11-01",
          "status": "Buildings 2 and 5 are operational, based on a 3-month fit-out period after structural completion in August, as can be seen from satellite imagery. Land clearing for the northern part of campus (buildings 10 and 11) has started.",
          "buildingsOperational": 3.0,
          "itPowerMw": 171.0,
          "h100Equivalent": 94492.1677614957,
          "capitalCostB": 6.477822000000001
        },
        {
          "date": "2025-12-01",
          "status": "Building 4 is operational, similarly based on a 3-month fit-out period after structural completion in September, as seen from satellite imagery.",
          "buildingsOperational": 4.0,
          "itPowerMw": 221.0,
          "h100Equivalent": 122789.28751894896,
          "capitalCostB": 8.371922
        },
        {
          "date": "2026-03-05",
          "status": "Satellite imagery shows four operational buildings (1, 2, 4, 5), and the western part of campus (6, 7, 8, 9) has made significant construction progress. The foundation for the northern part of campus (10, 11) has started.",
          "buildingsOperational": 4.0,
          "itPowerMw": 221.0,
          "h100Equivalent": 122789.28751894896,
          "capitalCostB": 8.371922
        },
        {
          "date": "2026-05-06",
          "status": "Satellite imagery shows building 9 has completed all its chillers, with only its roof remaining. Previous building completion timelines would imply this building will be operational by the end of 2026.",
          "buildingsOperational": 4.0,
          "itPowerMw": 221.0,
          "h100Equivalent": 122789.28751894896,
          "capitalCostB": 8.371922
        },
        {
          "date": "2027-09-01",
          "status": "Estimated: the nine-building section of the campus is projected to be fully operational by late 2027 or early 2028. VNET's eastern cluster (buildings 1-5) took roughly a year each from clearing to operational based on satellite imagery. The western cluster (buildings 6-9) was cleared in late 2024 but as of mid-2026 is not yet structurally complete, putting each on track for ~2 years from clearing to operational. Buildings 10 and 11 are projected to be completed sometime later. Comparable data centers in Ulanqab are expected to take at least 6 months per phase ([China Unicom](https://archive.ph/bJDHl)).",
          "buildingsOperational": 9.0,
          "itPowerMw": 700.0,
          "h100Equivalent": 388074.78524507326,
          "capitalCostB": 26.5174
        }
      ]
    },
    {
      "name": "Huawei Horinger",
      "slug": "huawei-horinger",
      "owner": "Huawei",
      "ownerConfidence": "confident",
      "users": [],
      "country": "China",
      "address": "Huawei, Horinger, China",
      "project": "",
      "currentChipTypes": [
        "Ascend 910C"
      ],
      "allChipTypes": [
        "Ascend 910C"
      ],
      "currentPowerMw": 241.8,
      "currentH100Equivalent": 117230.92470944922,
      "currentCapitalCostB": 9.159867600000002,
      "timeline": [
        {
          "date": "2023-10-08",
          "status": "Land clearing begins simultaneously for all three zones (west, north, and south) after an [official ceremony](https://web.archive.org/web/20260624112951/http://nmg.news.cn/20231008/57bb95be6791497db95bc7d2f229a68e/c.html). Two of the zones later have the cooling capacity indicative of AI workloads.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-02-24",
          "status": "Building 1 is structurally complete, and building 4 is structurally complete apart from some remaining cooling towers. Buildings 2 and 5 have begun construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-04-01",
          "status": "4 structure complete via satellite imagery",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-01",
          "status": "Building 1 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
          "buildingsOperational": 1.0,
          "itPowerMw": 47.6,
          "h100Equivalent": 23143.00151591713,
          "capitalCostB": 1.8031832000000003
        },
        {
          "date": "2025-07-01",
          "status": "Building 4 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
          "buildingsOperational": 2.0,
          "itPowerMw": 95.3,
          "h100Equivalent": 46235.472460838806,
          "capitalCostB": 3.6101545999999995
        },
        {
          "date": "2026-02-01",
          "status": "Building 2 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
          "buildingsOperational": 3.0,
          "itPowerMw": 150.2,
          "h100Equivalent": 72764.02223345124,
          "capitalCostB": 5.6898764
        },
        {
          "date": "2026-03-05",
          "status": "Three of the six (phase 1) buildings planned across the three zones are operational. One other is near completion, apart from backup generators. The third zone does not have cooling sufficient for AI.",
          "buildingsOperational": 3.0,
          "itPowerMw": 150.2,
          "h100Equivalent": 72764.02223345124,
          "capitalCostB": 5.6898764
        },
        {
          "date": "2026-05-12",
          "status": "Satellite imagery shows buildings 4 and 5 are all structurally finished, with landscaping complete.",
          "buildingsOperational": 3.0,
          "itPowerMw": 150.2,
          "h100Equivalent": 72764.02223345124,
          "capitalCostB": 5.6898764
        },
        {
          "date": "2026-06-07",
          "status": "Satellite imagery shows buildings 1, 2, 3, and 4 are all finished, with landscaping complete.",
          "buildingsOperational": 3.0,
          "itPowerMw": 150.2,
          "h100Equivalent": 72764.02223345124,
          "capitalCostB": 5.6898764
        },
        {
          "date": "2026-07-01",
          "status": "Building 5 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
          "buildingsOperational": 4.0,
          "itPowerMw": 241.8,
          "h100Equivalent": 117230.92470944922,
          "capitalCostB": 9.159867600000002
        }
      ]
    },
    {
      "name": "Google Red Oak",
      "slug": "google-red-oak",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "330 Austin Blvd, Red Oak, TX 75154",
      "project": "",
      "currentChipTypes": [
        "TPU v6e",
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v6e",
        "TPU v7"
      ],
      "currentPowerMw": 77.0,
      "currentH100Equivalent": 108135.42193026781,
      "currentCapitalCostB": 2.9169140000000002,
      "timeline": [
        {
          "date": "2023-04-30",
          "status": "First signs of development/land clearing",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-08-25",
          "status": "Building 1 is operational, based on a Google Earth [image](https://earth.google.com/web/@32.53855187,-96.7936939,182.71625265a,4648.56607908d,30.00094375y,3.66969189h,0t,0r/) showing a completed building shell and equipment, and the large construction car park being emptied. Building 2 shell looks mostly completed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 77.0,
          "h100Equivalent": 108135.42193026781,
          "capitalCostB": 2.9169140000000002
        },
        {
          "date": "2026-02-06",
          "status": "Building 1 appears active - the surrounding land is finished including the site entrance and the parking lot. The dry coolers for Building 2 are nearly complete although the building is still clearly a construction zone. The Building 2 substation also appears complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 77.0,
          "h100Equivalent": 108135.42193026781,
          "capitalCostB": 2.9169140000000002
        },
        {
          "date": "2026-12-01",
          "status": "Building 2 is estimated to be operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 154.0,
          "h100Equivalent": 315816.06872157654,
          "capitalCostB": 5.8338280000000005
        }
      ]
    },
    {
      "name": "Meta Gallatin",
      "slug": "meta-gallatin",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "1 Meta Lp, Gallatin, TN 37066",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 87.0,
      "currentH100Equivalent": 99545.22486104093,
      "currentCapitalCostB": 3.2957339999999995,
      "timeline": [
        {
          "date": "2023-09-11",
          "status": "Land clearing starts for Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-09",
          "status": "Building 1 shell and cooling looks complete, but construction equipment still seen around cooling and building. We estimate another 4 months to operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-15",
          "status": "Building 1 is operational (estimate).",
          "buildingsOperational": 1.0,
          "itPowerMw": 87.0,
          "h100Equivalent": 99545.22486104093,
          "capitalCostB": 3.2957339999999995
        }
      ]
    },
    {
      "name": "Meta Los Lunas",
      "slug": "meta-los-lunas",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "4250 Messenger Lp, Los Lunas, NM 87031",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 87.0,
      "currentH100Equivalent": 99545.22486104093,
      "currentCapitalCostB": 3.2957339999999995,
      "timeline": [
        {
          "date": "2024-07-24",
          "status": "Land clearing starts for new building.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-01",
          "status": "Building 1 looks operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 87.0,
          "h100Equivalent": 99545.22486104093,
          "capitalCostB": 3.2957339999999995
        }
      ]
    },
    {
      "name": "CoreWeave Ellendale ND",
      "slug": "coreweave-ellendale-nd",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "9685 87th Ave SE, Ellendale, ND 58436",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 68.0,
      "currentH100Equivalent": 93481.55634158666,
      "currentCapitalCostB": 2.5759760000000003,
      "timeline": [
        {
          "date": "2023-10-31",
          "status": "Start of construction for the first building, according to [Applied Digital](https://ir.applieddigital.com/news-events/press-releases/detail/75/applied-digital-announces-groundbreaking-of). CoreWeave was not leased yet at this site, but this is the construction start date we're using for relevance.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-05-28",
          "status": "CoreWeave signed the first lease package for 250 MW. No buildings online yet. This is according to an [SEC 8-k filing](https://www.sec.gov/Archives/edgar/data/1144879/000164117225013199/form8-k.htm) from this date.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-08-29",
          "status": "[A new 150 MW lease](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with) brings CoreWeave to 400 MW total contracted. The project is now clearly scheduled to be a three-building CoreWeave campus.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-27",
          "status": "The first 50 MW slice of Building 1 has reached Ready for Service status according to [this report](https://ir.applieddigital.com/news-events/press-releases/detail/133/applied-digital-achieves-ready-for-service-for-phase-1-at). This is the first point where we would count any CoreWeave capacity as operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 50.0,
          "h100Equivalent": 68721.57655381506,
          "capitalCostB": 1.8941
        },
        {
          "date": "2025-11-24",
          "status": "[This Applied Digital report](https://ir.applieddigital.com/news-events/press-releases/detail/137/applied-digital-completes-phase-ii-ready-for-service-at) says the rest of Building 1 has reached Ready for Service, bringing the first building to its expected 100 MW. We can treat this as the first completed data center building.",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 93481.55634158666,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2026-03-27",
          "status": "According to satellite imagery, Building 1 looks complete and in service, with the surrounding power/cooling equipment also operational. (Note: this image doesn't provide a view of buildings 2 or 3, though it's very safe to assume they're under construction at this stage, considering they're still under construction in the satellite image 3 months from now.)",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 93481.55634158666,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2026-06-30",
          "status": "According to satellite imagery, Building 2 is fully roofed and shell complete, with rooftop chillers mostly installed. Building 3 construction is well underway, with about 1/4 of the roofing done and the foundation laid out.",
          "buildingsOperational": 1.0,
          "itPowerMw": 68.0,
          "h100Equivalent": 93481.55634158666,
          "capitalCostB": 2.5759760000000003
        },
        {
          "date": "2026-12-31",
          "status": "According to the [schedule](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with), Building 2 should be online sometime in the second half of 2026. We can estimate the end of 2026 for 250 MW operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 88.0,
          "h100Equivalent": 300151.59171298635,
          "capitalCostB": 3.3336159999999997
        },
        {
          "date": "2027-06-01",
          "status": "According to [schedule](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with), Building 3 should come online in the first half of 2027. That would bring the full PF1 campus to 400 MW, according to the contract.",
          "buildingsOperational": 3.0,
          "itPowerMw": 400.0,
          "h100Equivalent": 505305.7099545225,
          "capitalCostB": 15.1528
        }
      ]
    },
    {
      "name": "Meta Sarpy",
      "slug": "meta-sarpy",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "14436-14998 Fairview Rd, Springfield, NE 68059, USA",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 80.0,
      "currentH100Equivalent": 91965.63921172309,
      "currentCapitalCostB": 3.03056,
      "timeline": [
        {
          "date": "2024-08-01",
          "status": "Building 1 grading underway.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-04",
          "status": "Building 1 shell, electrical and cooling equipment looks complete, with minimal construction work, so we expect it to be operational within 3 months.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-08-02",
          "status": "Building 1 is operational (estimate).",
          "buildingsOperational": 1.0,
          "itPowerMw": 80.0,
          "h100Equivalent": 91965.63921172309,
          "capitalCostB": 3.03056
        }
      ]
    },
    {
      "name": "CoreWeave Chester VA",
      "slug": "coreweave-chester-va",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "1401 Meadowville Technology Parkway, Chester, VA",
      "project": "",
      "currentChipTypes": [
        "H100",
        "B200"
      ],
      "allChipTypes": [
        "H100",
        "B200"
      ],
      "currentPowerMw": 82.0,
      "currentH100Equivalent": 88428.49924204143,
      "currentCapitalCostB": 3.106324,
      "timeline": [
        {
          "date": "2023-09-18",
          "status": "Conversion starts at CTP-01 (Building 1). The data center was formerly owned by Capital One, now leased to CoreWeave. Source: https://www.datacenterdynamics.com/en/news/chirisa-secures-200-million-loan-to-fit-out-virginia-data-center-for-coreweave/",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-01-31",
          "status": "Building 1's second data hall scheduled to come online this month.",
          "buildingsOperational": 1.0,
          "itPowerMw": 18.0,
          "h100Equivalent": 14805.45730166751,
          "capitalCostB": 0.6818759999999999
        },
        {
          "date": "2024-04-30",
          "status": "Building 1 is scheduled to be fully online by this point, so I count the full 27 MW here.",
          "buildingsOperational": 1.0,
          "itPowerMw": 27.0,
          "h100Equivalent": 22081.85952501263,
          "capitalCostB": 1.022814
        },
        {
          "date": "2025-01-22",
          "status": "Satellite imagery shows Building 1 complete, with Building 2's yard work and early construction visible. Building 3 hasn't started yet, since the old building is still there.",
          "buildingsOperational": 1.0,
          "itPowerMw": 27.0,
          "h100Equivalent": 22081.85952501263,
          "capitalCostB": 1.022814
        },
        {
          "date": "2026-05-20",
          "status": "Based on satellite imagery, Building 3 has cleared its land and is beginning construction. Building 2 is operational judging from the colored motion artifacts on the cooling tower fans.",
          "buildingsOperational": 2.0,
          "itPowerMw": 82.0,
          "h100Equivalent": 88428.49924204143,
          "capitalCostB": 3.106324
        },
        {
          "date": "2027-06-30",
          "status": "Buildings 3 is estimated complete by the end of Q1 2027, based on the current PowerHouse schedule. Added another three months to account for commissioning and server installation.",
          "buildingsOperational": 3.0,
          "itPowerMw": 113.0,
          "h100Equivalent": 125821.1217786761,
          "capitalCostB": 4.280666
        }
      ]
    },
    {
      "name": "Oracle Batam",
      "slug": "oracle-batam",
      "owner": "Oracle",
      "ownerConfidence": "likely",
      "users": [],
      "country": "Indonesia",
      "address": "",
      "project": "",
      "currentChipTypes": [
        "B200",
        "B300"
      ],
      "allChipTypes": [
        "B200",
        "B300"
      ],
      "currentPowerMw": 72.0,
      "currentH100Equivalent": 84386.05356240526,
      "currentCapitalCostB": 2.7275039999999997,
      "timeline": [
        {
          "date": "2022-07-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-05-15",
          "status": "Building 1 and 2 are operational. Based on Oracle [announcing](https://docs.oracle.com/en-us/iaas/releasenotes/oci/new-region-batam.htm) the Indonesia North (Batam) region is available, and both buildings looking complete soon after, in June.",
          "buildingsOperational": 2.0,
          "itPowerMw": 33.0,
          "h100Equivalent": 40424.456796361796,
          "capitalCostB": 1.2501060000000002
        },
        {
          "date": "2025-06-13",
          "status": "Building 3 shell is partly built. Building 1 and 2 look complete.",
          "buildingsOperational": 2.0,
          "itPowerMw": 33.0,
          "h100Equivalent": 40424.456796361796,
          "capitalCostB": 1.2501060000000002
        },
        {
          "date": "2025-10-01",
          "status": "Building 3 has cooling towers beginning to be installed.",
          "buildingsOperational": 2.0,
          "itPowerMw": 33.0,
          "h100Equivalent": 40424.456796361796,
          "capitalCostB": 1.2501060000000002
        },
        {
          "date": "2026-03-19",
          "status": "Building 3 looks complete including building shell, chillers and backup generators.",
          "buildingsOperational": 2.0,
          "itPowerMw": 33.0,
          "h100Equivalent": 40424.456796361796,
          "capitalCostB": 1.2501060000000002
        },
        {
          "date": "2026-04-17",
          "status": "Building 3 is operational. Based on it looking complete as of March, and DayOne [posting](https://www.linkedin.com/posts/dayonedc-datacenter-batam-ugcPost-7450899048925986816-Wxqu/) a video of the facility on this date. In one shot of the video, fan movement is visible for all buildings, suggesting they are all operational.",
          "buildingsOperational": 3.0,
          "itPowerMw": 72.0,
          "h100Equivalent": 84386.05356240526,
          "capitalCostB": 2.7275039999999997
        },
        {
          "date": "2026-05-06",
          "status": "The three buildings look unchanged since March.",
          "buildingsOperational": 3.0,
          "itPowerMw": 72.0,
          "h100Equivalent": 84386.05356240526,
          "capitalCostB": 2.7275039999999997
        }
      ]
    },
    {
      "name": "Google Papillion",
      "slug": "google-papillion",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "14651-15249 Gold Coast Rd 68138 Papillion Nebraska, USA",
      "project": "",
      "currentChipTypes": [
        "TPU v4",
        "TPU v5e",
        "TPU v6e",
        "TPU v5p"
      ],
      "allChipTypes": [
        "TPU v4",
        "TPU v5e",
        "TPU v6e",
        "TPU v5p"
      ],
      "currentPowerMw": 237.0,
      "currentH100Equivalent": 80343.60788276908,
      "currentCapitalCostB": 8.978034,
      "timeline": [
        {
          "date": "2020-03-04",
          "status": "Land clearing begins for Building 1 of expansion.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2022-10-16",
          "status": "Building 2 under construction. Building 3 begins construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2023-01-23",
          "status": "Building 1 assumed operational due to vapor from cooling towers. Building 2 4/7 cooling towers installed. Building 3 roof complete coverage but unfinished.",
          "buildingsOperational": 1.0,
          "itPowerMw": 79.0,
          "h100Equivalent": 20970.186963112683,
          "capitalCostB": 2.992678
        },
        {
          "date": "2024-02-15",
          "status": "Building 2 assumed operational due to vapor from cooling towers. Building 3 5/7 cooling towers installed.",
          "buildingsOperational": 1.0,
          "itPowerMw": 79.0,
          "h100Equivalent": 20970.186963112683,
          "capitalCostB": 2.992678
        },
        {
          "date": "2024-08-03",
          "status": "Building 3 look operational.",
          "buildingsOperational": 3.0,
          "itPowerMw": 237.0,
          "h100Equivalent": 80343.60788276908,
          "capitalCostB": 8.978034
        },
        {
          "date": "2025-11-03",
          "status": "Land cleared for Building 4 and 5.",
          "buildingsOperational": 3.0,
          "itPowerMw": 237.0,
          "h100Equivalent": 80343.60788276908,
          "capitalCostB": 8.978034
        },
        {
          "date": "2026-05-04",
          "status": "Building 4 shell mostly complete, Building 5 steel framing is underway.",
          "buildingsOperational": 3.0,
          "itPowerMw": 237.0,
          "h100Equivalent": 80343.60788276908,
          "capitalCostB": 8.978034
        }
      ]
    },
    {
      "name": "CoreWeave Marble NC",
      "slug": "coreweave-marble-nc",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "155 Palmer Ln, Marble, NC 28905",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 65.0,
      "currentH100Equivalent": 78827.6907529055,
      "currentCapitalCostB": 2.46233,
      "timeline": [
        {
          "date": "2024-06-25",
          "status": "Core Scientific announced that CoreWeave would receive about 70 MW of HPC infrastructure from 100 MW of owned infrastructure. Site modifications were expected to begin in H2 2024.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-02",
          "status": "Marble had achieved full site energization. Two of three data halls had been delivered at 36 billable MW, supporting about 15000 Grace Blackwell GPUs. The third hall was still in commissioning.",
          "buildingsOperational": 1.0,
          "itPowerMw": 36.0,
          "h100Equivalent": 43456.291056088936,
          "capitalCostB": 1.3637519999999999
        },
        {
          "date": "2026-04-17",
          "status": "Satellite imagery shows the main data hall and southern utility yard substantially complete. No new public MW disclosure, so this keeps the March 2026 public 36 MW state.",
          "buildingsOperational": 1.0,
          "itPowerMw": 36.0,
          "h100Equivalent": 43456.291056088936,
          "capitalCostB": 1.3637519999999999
        },
        {
          "date": "2026-05-06",
          "status": "Core Scientific said Marble was fully handed over to CoreWeave with about 65 MW of billable customer power online.",
          "buildingsOperational": 1.0,
          "itPowerMw": 65.0,
          "h100Equivalent": 78827.6907529055,
          "capitalCostB": 2.46233
        }
      ]
    },
    {
      "name": "Microsoft SAT40",
      "slug": "microsoft-sat40",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "15000 Lambda Drive, San Antonio, TX 78245",
      "project": "",
      "currentChipTypes": [
        "H100",
        "B300"
      ],
      "allChipTypes": [
        "H100",
        "B300"
      ],
      "currentPowerMw": 75.0,
      "currentH100Equivalent": 64679.13087417888,
      "currentCapitalCostB": 2.84115,
      "timeline": [
        {
          "date": "2018-12-28",
          "status": "Land clearing begins for the site, specifically digging up a parking lot and making outlines for the buildings. Evident on [Google Earth](https://earth.google.com/web/@29.4149522,-98.80304495,292.48816289a,1532.49619452d,35y,0h,0t,0r/).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-05-24",
          "status": "Building 1 operational. Estimated 3 months out from February, when there was still construction equipment.",
          "buildingsOperational": 1.0,
          "itPowerMw": 47.0,
          "h100Equivalent": 32390.096008084893,
          "capitalCostB": 1.7804540000000002
        },
        {
          "date": "2025-12-01",
          "status": "Building 2 operational. No more construction on building, and surrounding roads are also complete.",
          "buildingsOperational": 2.0,
          "itPowerMw": 75.0,
          "h100Equivalent": 64679.13087417888,
          "capitalCostB": 2.84115
        },
        {
          "date": "2026-02-04",
          "status": "Site has already been completed, with no more visible construction on any building.",
          "buildingsOperational": 2.0,
          "itPowerMw": 75.0,
          "h100Equivalent": 64679.13087417888,
          "capitalCostB": 2.84115
        }
      ]
    },
    {
      "name": "STACK Infrastructure NVA02",
      "slug": "stack-infrastructure-nva02",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "9590 Hornbaker Rd, Manassas, VA 20109",
      "project": "",
      "currentChipTypes": [
        "H100"
      ],
      "allChipTypes": [
        "H100"
      ],
      "currentPowerMw": 85.0,
      "currentH100Equivalent": 61141.99090449722,
      "currentCapitalCostB": 3.21997,
      "timeline": [
        {
          "date": "2019-10-19",
          "status": "Land clearing begins by Peterson Companies for Stack Infrastructure, which is noted in the [news](https://www.bisnow.com/washington-dc/news/data-center/peterson-cos-partnering-to-build-4m-sf-data-center-campus-in-manassas-102646) and visible on satellite imagery.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-10-01",
          "status": "Building 1 is operational, which is assumed to be three months after the last backup diesel generators are finished. The generators were first seen to be finished July 1 from satellite imagery [(a clear image of this can be seen on July 29 via Google Earth).](https://earth.google.com/web/search/38%c2%b044%2745%2e12%22N+77%c2%b032%2716%2e47%22W/@38.7458667,-77.5379083,83.89135729a,642.01325639d,35y,0h,0t,0r/data=CjQiJgokCTo0Rh9P7TVAETk0Rh9P7TXAGX6C6a6li0VAIQ_0AAa-ik7AKgYIARIAGAFCAggBQgIIAEoNCP___________wEQAA)",
          "buildingsOperational": 1.0,
          "itPowerMw": 85.0,
          "h100Equivalent": 61141.99090449722,
          "capitalCostB": 3.21997
        },
        {
          "date": "2026-02-14",
          "status": "All buildings have begun construction (with groundwork starting for AI building 6), as depicted by satellite imagery.",
          "buildingsOperational": 1.0,
          "itPowerMw": 85.0,
          "h100Equivalent": 61141.99090449722,
          "capitalCostB": 3.21997
        },
        {
          "date": "2028-01-01",
          "status": "Estimate: All 6 AI data center buildings will be finished in 2028, assuming a groundbreak-to-operational timeline of 18-24 months. One is complete, three are clearly under construction, and the last two data centers are still breaking ground and laying foundations.",
          "buildingsOperational": 6.0,
          "itPowerMw": 348.0,
          "h100Equivalent": 250631.63213744314,
          "capitalCostB": 13.182935999999998
        }
      ]
    },
    {
      "name": "Anthropic Lake Mariner",
      "slug": "anthropic-lake-mariner",
      "owner": "AI XPV Platform",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Anthropic",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "7725 Lake Rd, Barker, NY 14012",
      "project": "",
      "currentChipTypes": [
        "TPU v7"
      ],
      "allChipTypes": [
        "TPU v7"
      ],
      "currentPowerMw": 42.0,
      "currentH100Equivalent": 58564.93178372915,
      "currentCapitalCostB": 1.5910440000000001,
      "timeline": [
        {
          "date": "2025-06-11",
          "status": "Land clearing begins for Building 1 (AKA CB3).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-02",
          "status": "Building 1 appears to have a complete shell and cooling equipment. Building 2 shell is still under construction, but 17 cooling units are already loaded on the roof. The outline of Building 3 is visible at the foundation.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-31",
          "status": "Building 1 is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB3 was expected to be energized by mid-May 2026. A drone video commissioned from [RAAD](https://raad.com/) shows several cooling units operating on May 8. It's therefore likely that the building was fully operational around this date.",
          "buildingsOperational": 1.0,
          "itPowerMw": 42.0,
          "h100Equivalent": 58564.93178372915,
          "capitalCostB": 1.5910440000000001
        },
        {
          "date": "2026-07-23",
          "status": "Building 1 looks complete, consistent with it going operational back in May. Building 2 is mostly complete, with the row of backup generators on the east side of the building still being installed. Building 3 shell is complete, with rooftop coolers midway through installation, and no neighboring generators installed/visible yet.",
          "buildingsOperational": 1.0,
          "itPowerMw": 42.0,
          "h100Equivalent": 58564.93178372915,
          "capitalCostB": 1.5910440000000001
        },
        {
          "date": "2026-10-31",
          "status": "Building 2 (AKA CB4) is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB4 was expected to be energized by Q3 2026.",
          "buildingsOperational": 2.0,
          "itPowerMw": 210.0,
          "h100Equivalent": 292829.71197574533,
          "capitalCostB": 7.955219999999999
        },
        {
          "date": "2027-03-31",
          "status": "Building 3 (AKA CB5) is operational. On February 26, 2026, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB5 was expected to be energized by Q4 2026. However, based on the pace of Building 2, and comparisons to other projects like Stargate Abilene, we think this is optimistic. We expect a 3-month delay past the end of Q4 2026 to get to full operational capacity.",
          "buildingsOperational": 3.0,
          "itPowerMw": 378.0,
          "h100Equivalent": 527084.3860535624,
          "capitalCostB": 14.319396
        }
      ]
    },
    {
      "name": "Microsoft-Nebius New Jersey",
      "slug": "microsoft-nebius-new-jersey",
      "owner": "Nebius",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Microsoft",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "3963 S Lincoln Ave, Vineland, New Jersey",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 50.0,
      "currentH100Equivalent": 56846.89236988378,
      "currentCapitalCostB": 1.8941,
      "timeline": [
        {
          "date": "2024-05-31",
          "status": "Land clearing begins for northern two buildings (Building 1-2).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": null,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-15",
          "status": "By mid-December 2025 the building was still not complete. A satellite analysis by SemiAnalysis found that the air-cooled chillers serving the second half of the first 50 MW phase were not yet installed, so the phase was not yet operational. SemiAnalysis estimated the full 50 MW would be reached around January to February 2026.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-15",
          "status": "High-resolution satellite imagery shows the air-cooled chiller array has grown to roughly 30 units, enough to support the first phase. We estimate Building 1 became operational around early 2026 with about 50 MW of IT capacity (70 MW total facility power at a 1.4 PUE), based on DataOne's disclosure of a first 50 MW phase. SemiAnalysis estimated the full 50 MW was reached around January to February 2026 ([SemiAnalysis](https://newsletter.semianalysis.com/p/stop-saying-half-of-2026-us-datacenter)); this April image is our first high-resolution confirmation that the cooling is in place.",
          "buildingsOperational": 1.0,
          "itPowerMw": 50.0,
          "h100Equivalent": 56846.89236988378,
          "capitalCostB": 1.8941
        },
        {
          "date": "2026-07-12",
          "status": "Compared with the April 2026 image, the building shell is closer to completion, and several additional air-cooled chillers have appeared on the ground, though they do not yet appear to be connected or operating. We therefore keep IT capacity at 50 MW.",
          "buildingsOperational": 1.0,
          "itPowerMw": 50.0,
          "h100Equivalent": 56846.89236988378,
          "capitalCostB": 1.8941
        }
      ]
    },
    {
      "name": "Southgate Melbourne",
      "slug": "southgate-melbourne",
      "owner": "Firmus",
      "ownerConfidence": "confident",
      "users": [],
      "country": "Australia",
      "address": "",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 41.0,
      "currentH100Equivalent": 46488.12531581607,
      "currentCapitalCostB": 1.553162,
      "timeline": [
        {
          "date": "2022-12-26",
          "status": "Building 1 site is cleared/vacant land; no construction visible yet (based on Google Earth historical imagery).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-28",
          "status": "Satellite imagery shows 30 fully installed air-cooled chillers (20 fans each) on the roof, with room for many more. In the same month, Firmus [reported](https://firmus.co/newsroom/southgate-expansion) that Project Southgate's \"first stages are under construction in Tasmania and Melbourne\". So we don't think the Southgate part of the building is operational yet.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-11",
          "status": "Building 1's cooling capacity increased to 53 air-cooled chillers (20 fans each), up from 30 in Oct 2025. This is more than enough for the announced 18,400 GB300 GPUs, but construction does not quite look complete, so we expect another 3 months until it's operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-08-09",
          "status": "Building 1 is operational (estimate). No additional chip deployment beyond the 18,400 GB300 GPUs has been publicly confirmed, so we continue to report the disclosed capacity allocated to Project Southgate, rather than speculate on further buildout.",
          "buildingsOperational": 1.0,
          "itPowerMw": 41.0,
          "h100Equivalent": 46488.12531581607,
          "capitalCostB": 1.553162
        }
      ]
    },
    {
      "name": "Stream Phoenix",
      "slug": "stream-phoenix",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "2950 S. Litchfield Road",
      "project": "",
      "currentChipTypes": [
        "H100"
      ],
      "allChipTypes": [
        "H100"
      ],
      "currentPowerMw": 64.0,
      "currentH100Equivalent": 46134.4113188479,
      "currentCapitalCostB": 2.424448,
      "timeline": [
        {
          "date": "2022-10-30",
          "status": "Construction beginning, as can be seen on satellite. Major renovations on western side of the non AI building (PX1), including adding generators and cooling towers.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-31",
          "status": "Major construction has finished on AI building 1, and AI building 6 has been expedited, as depicted by satellite imagery.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-05-01",
          "status": "Estimated: AI building 1 should be operational. Major construction work finished by January 31, 2026, and the shell looked complete by that date. We estimate after three months the building will be operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 64.0,
          "h100Equivalent": 46134.4113188479,
          "capitalCostB": 2.424448
        },
        {
          "date": "2030-01-01",
          "status": "Although official [promotional sources](https://www.streamdatacenters.com/wp-content/uploads/2026/01/SDC-Goodyear-CaseStudy-251218.pdf) estimate the campus to be fully operational in 10-12 years, it is likely to be finished sooner than this given the empirical durations for other data center campuses as well as because AI building 6 has been expedited. The first AI building took approximately 24 months to complete. Assuming construction for a new building starts midway for every building, then the campus will be complete in 4 years for the 5 remaining buildings, since AI buildings 2 and 6 are both underway.",
          "buildingsOperational": 6.0,
          "itPowerMw": 220.0,
          "h100Equivalent": 160181.91005558363,
          "capitalCostB": 8.33404
        }
      ]
    },
    {
      "name": "Microsoft SAT14",
      "slug": "microsoft-sat14",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [],
      "country": "United States",
      "address": "3545 Wiseman Boulevard, San Antonio, TX 78251",
      "project": "",
      "currentChipTypes": [
        "H100",
        "B300"
      ],
      "allChipTypes": [
        "H100",
        "B300"
      ],
      "currentPowerMw": 47.0,
      "currentH100Equivalent": 45174.33046993431,
      "currentCapitalCostB": 1.7804540000000002,
      "timeline": [
        {
          "date": "2022-02-18",
          "status": "Land clearing for the site is almost complete. Informed using imagery on [Google Earth](https://earth.google.com/web/@29.476115,-98.68118,277.21295794a,724.52967601d,35y,0h,0t,0r/)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-07-01",
          "status": "Building 1 operational. The first 2 data halls of Building 1 (with chillers already installed) are likely to be already operational. Although construction was completed prior, the on-site substation was previously incomplete, so we believe it was only operational at this point.",
          "buildingsOperational": 1.0,
          "itPowerMw": 19.0,
          "h100Equivalent": 12986.356745831228,
          "capitalCostB": 0.719758
        },
        {
          "date": "2025-08-03",
          "status": "Building 2 chiller installation is a little more than halfway complete, and chiller installation for the last data hall of Building 1 is also around halfway complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 19.0,
          "h100Equivalent": 12986.356745831228,
          "capitalCostB": 0.719758
        },
        {
          "date": "2026-02-28",
          "status": "No more visible construction around either building, just a little equipment. Roads fully built around buildings as well.",
          "buildingsOperational": 1.0,
          "itPowerMw": 19.0,
          "h100Equivalent": 12986.356745831228,
          "capitalCostB": 0.719758
        },
        {
          "date": "2026-03-31",
          "status": "Building 2 fully operational, Building 1 expanded. Construction is already visibly complete. Additionally, construction phases [Phase 2](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019471), [Phase 3](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019588), and [Phase 4](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019686) on TDLR that collectively represent the completion of the site have a completion date of 2026-03-31.",
          "buildingsOperational": 2.0,
          "itPowerMw": 47.0,
          "h100Equivalent": 45174.33046993431,
          "capitalCostB": 1.7804540000000002
        }
      ]
    },
    {
      "name": "Vantage TX1",
      "slug": "vantage-tx1",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "14720 Omicron Dr, San Antonio, TX 78245",
      "project": "",
      "currentChipTypes": [
        "B200"
      ],
      "allChipTypes": [
        "B200"
      ],
      "currentPowerMw": 32.0,
      "currentH100Equivalent": 38706.417382516425,
      "currentCapitalCostB": 1.212224,
      "timeline": [
        {
          "date": "2023-12-15",
          "status": "Land clearing begins for both Building 1 & Building 2",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-15",
          "status": "Building 1 operational; Roads around Building 1 complete, all cooling and side generator equipment construction has since finished as well. Although this is still earlier than the completion date reported on TDLR, based on the appearance, we believe it is operational. Reported IT power of 32 MW. [Source](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2024007561)",
          "buildingsOperational": 1.0,
          "itPowerMw": 32.0,
          "h100Equivalent": 38706.417382516425,
          "capitalCostB": 1.212224
        },
        {
          "date": "2027-08-31",
          "status": "Estimated construction completion date of Building 2. [Construction Project Filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026001234)",
          "buildingsOperational": 2.0,
          "itPowerMw": 128.0,
          "h100Equivalent": 154623.54724608388,
          "capitalCostB": 4.848896
        }
      ]
    },
    {
      "name": "CoreWeave Dalton 1 & 2",
      "slug": "coreweave-dalton-1-2",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "2205 Industrial South Rd, Dalton, GA, 30721",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 28.0,
      "currentH100Equivalent": 32238.504295098533,
      "currentCapitalCostB": 1.060696,
      "timeline": [
        {
          "date": "2024-06-03",
          "status": "According to a [few](https://investors.corescientific.com/news-events/press-releases/detail/74/core-scientific-to-provide-approximately-200-mw-of-infrastructure-to-host-coreweaves-high-performance-computing-services-capturing-significant-ai-compute-opportunity) [sources](https://www.sec.gov/Archives/edgar/data/1839341/000162828025008302/core-20241231.htm), Core Scientific announced that they're rebuilding their existing Dalton 1 (and we're assuming 2) datacenter to run AI using CoreWeave's GPUs, of which contract was first signed on this date. According to the press release, \"The site modifications are expected to commence early in the second half of 2024 and achieve operational status in the first half of 2025.\"",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-05-01",
          "status": "Core Scientific investor presentation clearly shows Dalton 1 with a cleared pad on this month for construction. Source: https://investors.corescientific.com/sec-filings/all-sec-filings/content/0001140361-25-039864/0001140361-25-039864.pdf",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-08-29",
          "status": "Based on Satellite imagery, Dalton 1 is still under construction. The building appears mostly roofed except for the entrance area, and there are no cooling units or backup generators installed yet.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-20",
          "status": "Building 1 is operational, given it was announced completed 4 months ago and looks completed in satellite imagery. All cooling/mechanical rows are installed, with no obvious active building construction visible.",
          "buildingsOperational": 1.0,
          "itPowerMw": 28.0,
          "h100Equivalent": 32238.504295098533,
          "capitalCostB": 1.060696
        }
      ]
    },
    {
      "name": "Alibaba Zhangbei",
      "slug": "alibaba-zhangbei",
      "owner": "Alibaba",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Alibaba",
          "confidence": "likely"
        }
      ],
      "country": "China",
      "address": "Alibaba Zhangbei Yun Calculation Data Center, Zhangbei County, Zhangjiakou, Hebei, China, 076471",
      "project": "",
      "currentChipTypes": [
        "H20"
      ],
      "allChipTypes": [
        "H20"
      ],
      "currentPowerMw": 169.0,
      "currentH100Equivalent": 31884.79029813037,
      "currentCapitalCostB": 6.402058,
      "timeline": [
        {
          "date": "2024-07-23",
          "status": "New chiller configuration starts getting installed on Building 1-3.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-09-17",
          "status": "Large substation is visibly connected to transmission lines. New chillers look fully installed on Building 1-3. Since power and cooling is apparently in place, we expect Building 1-3 are operational. Chillers are almost installed on Building 4-6, with construction equipment still around the building.",
          "buildingsOperational": 3.0,
          "itPowerMw": 85.0,
          "h100Equivalent": 15967.660434562911,
          "capitalCostB": 3.21997
        },
        {
          "date": "2025-12-23",
          "status": "Chillers look fully installed on Building 4-6. Some chillers on Building 4 and 5 appear to have snow in the fan holes, suggesting they are not operating and other chillers are operating (since warm air would melt the snow). There is still a bit of construction equipment around Building 6 so it may not be quite operational.",
          "buildingsOperational": 3.0,
          "itPowerMw": 85.0,
          "h100Equivalent": 15967.660434562911,
          "capitalCostB": 3.21997
        },
        {
          "date": "2026-01-03",
          "status": "Expect Building 4-6 have finished upgrading with new chillers.",
          "buildingsOperational": 6.0,
          "itPowerMw": 169.0,
          "h100Equivalent": 31884.79029813037,
          "capitalCostB": 6.402058
        }
      ]
    },
    {
      "name": "Start Campus Sines Data Campus",
      "slug": "start-campus-sines-data-campus",
      "owner": "Nscale",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Microsoft",
          "confidence": "confident"
        }
      ],
      "country": "Portugal",
      "address": "Start Campus - Sustainable Data Center Services, Sines, Portugal",
      "project": "",
      "currentChipTypes": [
        "B300"
      ],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 33.0,
      "currentH100Equivalent": 31834.259727134915,
      "currentCapitalCostB": 1.2501060000000002,
      "timeline": [
        {
          "date": "2022-01-01",
          "status": "Land clearing begins for Building 1 (SIN01)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-10-31",
          "status": "Building 1 (SIN01) is completed, but at this point it likely not being used for AI as the collaboration with Microsoft that resulted in GB300s did not occur until Q1 2026. The completion is based both on satellite imagery, which shows the building fully completed, and a [March 2025 article](https://econews.pt/2025/03/24/start-campus-to-start-construction-of-second-data-centre-building-in-sines-by-end-june/) that says it \"has been in operation since October\", which is October of 2024.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-03",
          "status": "Building 1 (SIN01) operational for AI, with the first deployment of 12,600 Nvidia GB300 NVL72s to the site being reported completed \"Q1 2026\" based on the [corporate announcement](https://lp.startcampus.pt/start-campus-hosts-eus-first-nvidia-gb300-chips-with-nscale-for-microsoft). Land clearing also begins for Building 2 (SIN02), with faint dirt outlines for roads and building foundations visible.",
          "buildingsOperational": 1.0,
          "itPowerMw": 33.0,
          "h100Equivalent": 31834.259727134915,
          "capitalCostB": 1.2501060000000002
        },
        {
          "date": "2027-09-30",
          "status": "Building 2 (SIN02) projected to be operational. This is based on the timeline provided in the [factsheet](https://23712035.hs-sites.com/hubfs/SINES_02.PDF.pdf?hsCtaAttrib=199407154715) for the site. We expect VR200 GPUs to be used as a lot of those chips will have already been available in September 2027, and the \"up to 600kW racks\" in the factsheet suggest they are aiming for this.",
          "buildingsOperational": 2.0,
          "itPowerMw": 233.0,
          "h100Equivalent": 540677.109651339,
          "capitalCostB": 8.826506
        }
      ]
    },
    {
      "name": "Google Pryor (North)",
      "slug": "google-pryor-north",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "4581 Webb St, Pryor, OK 74361",
      "project": "",
      "currentChipTypes": [
        "TPU v5p",
        "TPU v5e"
      ],
      "allChipTypes": [
        "TPU v5p",
        "TPU v5e"
      ],
      "currentPowerMw": 53.0,
      "currentH100Equivalent": 26275.896917635167,
      "currentCapitalCostB": 2.007746,
      "timeline": [
        {
          "date": "2024-07-19",
          "status": "Building 1 is operational, based on default roof-to-operational time.",
          "buildingsOperational": 1.0,
          "itPowerMw": 53.0,
          "h100Equivalent": 26275.896917635167,
          "capitalCostB": 2.007746
        },
        {
          "date": "2025-01-28",
          "status": "Building 2 is being retrofitted from a warehouse. The roof is being painted white, and cooling towers and a new substation are being built just south of the building (based on later imagery).",
          "buildingsOperational": 1.0,
          "itPowerMw": 53.0,
          "h100Equivalent": 26275.896917635167,
          "capitalCostB": 2.007746
        },
        {
          "date": "2025-10-19",
          "status": "The new substation for Building 2 looks mostly complete, half of the cooling towers are installed. The black patch in the top left of the building suggests that the new roof is not quite complete.",
          "buildingsOperational": 1.0,
          "itPowerMw": 53.0,
          "h100Equivalent": 26275.896917635167,
          "capitalCostB": 2.007746
        },
        {
          "date": "2026-05-26",
          "status": "Building 2 looks almost complete, but still appears to have three cooling towers missing. We therefore expect another 3 months until full operation.",
          "buildingsOperational": 1.0,
          "itPowerMw": 53.0,
          "h100Equivalent": 26275.896917635167,
          "capitalCostB": 2.007746
        },
        {
          "date": "2026-08-24",
          "status": "Building 2 is operational (estimate).",
          "buildingsOperational": 2.0,
          "itPowerMw": 368.0,
          "h100Equivalent": 763011.622031329,
          "capitalCostB": 13.940576
        }
      ]
    },
    {
      "name": "xAI QTS Atlanta",
      "slug": "xai-qts-atlanta",
      "owner": "SpaceXAI",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "SpaceXAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "1025 Jefferson Street NW, Atlanta, GA 30318",
      "project": "",
      "currentChipTypes": [
        "H100",
        "A100"
      ],
      "allChipTypes": [
        "H100",
        "A100"
      ],
      "currentPowerMw": 17.32971,
      "currentH100Equivalent": 11470.43961596766,
      "currentCapitalCostB": 0.6564840742199999,
      "timeline": [
        {
          "date": "2024-01-23",
          "status": "X Corp's $700 million investment in AI training hardware for the Atlanta data center is approved by the Development Authority of Fulton County ([bond resolution fact sheet](https://www.developfultoncounty.com/meetings-and-minutes_239_547601452.pdf)).",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-02-20",
          "status": "xAI's GPU cluster in the QTS Atlanta building at 1025 Jefferson Street NW is operational around this time. This date is a tentative estimate: Business Insider reported the buildout in February 2025, so the cluster likely came online around or shortly after then, though the exact date is not disclosed. The cluster comprises 11,000 NVIDIA H100 and about 1,448 A100 GPUs, based on documents submitted to Develop Fulton as [reported by Business Insider](https://www.businessinsider.com/xai-elon-musk-x-new-atlanta-data-center-2025-2). xAI occupies part of this multi-tenant building, so its cooling is not attributed to xAI alone.",
          "buildingsOperational": 1.0,
          "itPowerMw": 17.32971,
          "h100Equivalent": 11470.43961596766,
          "capitalCostB": 0.6564840742199999
        },
        {
          "date": "2025-08-21",
          "status": "No significant change to the building since the cluster became operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 17.32971,
          "h100Equivalent": 11470.43961596766,
          "capitalCostB": 0.6564840742199999
        },
        {
          "date": "2026-07-10",
          "status": "No significant change to the building since the August 2025 image.",
          "buildingsOperational": 1.0,
          "itPowerMw": 17.32971,
          "h100Equivalent": 11470.43961596766,
          "capitalCostB": 0.6564840742199999
        }
      ]
    },
    {
      "name": "CoreWeave Muskogee OK",
      "slug": "coreweave-muskogee-ok",
      "owner": "CoreWeave",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "1525 W 43rd St S, Muskogee, OK 74401, USA",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [
        "B300"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2024-11-18",
          "status": "Core Scientific, CoreWeave, and Port Muskogee publicly announce groundbreaking for the 100 MW Muskogee HPC data center. Core Scientific [says](https://investors.corescientific.com/news-events/press-releases/detail/99/core-scientific-and-port-muskogee-break-ground-on-100-mw-hpc-data-center) the site will provide about 70 MW of critical IT load for CoreWeave's NVIDIA GPUs.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-09",
          "status": "Based on satellite imagery, Building 1 looks mostly complete, but the site still appears to be in construction or commissioning. Not much progress has happened in the past 4 months, and a Q2 2026 finish seems unlikely.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-13",
          "status": "Based on satellite imagery, Building 1 has completed construction, with adjacent land cleared for what we're assuming will have power substations/generators. We can assume Building 1 is not operational from all the yard work directly surrounding it, and the lack of a parking lot. Building 2 (The one not leased to CoreWeave) is still in land clearing phase.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-31",
          "status": "Estimating building 1 is operational by the end of the year, judging from the building currently completed, the completed power substation to the southwest. The surrounding yard work/construction will likely still take several months, judging from the slow pace.",
          "buildingsOperational": 1.0,
          "itPowerMw": 70.0,
          "h100Equivalent": 90955.02779181405,
          "capitalCostB": 2.65174
        },
        {
          "date": "2027-12-31",
          "status": "Core Scientific expects initial delivery of the second, unleased 82.5 MW Muskogee building in Q4 2027. Not signed to have CoreWeave GPUs as of yet, but may change in the future. Source: https://www.sec.gov/Archives/edgar/data/1839341/000162828026030918/exhibit991polarispressre.htm",
          "buildingsOperational": 2.0,
          "itPowerMw": 153.0,
          "h100Equivalent": 198079.8383021728,
          "capitalCostB": 5.795946
        }
      ]
    },
    {
      "name": "Crusoe Abilene Expansion",
      "slug": "crusoe-abilene-expansion",
      "owner": "Microsoft",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Microsoft",
          "confidence": "likely"
        }
      ],
      "country": "United States",
      "address": "5502 Spinks Rd, Abilene, TX 79601",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-11-02",
          "status": "Land clearing begins for Buildings 1-2.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-15",
          "status": "Land clearing continues.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2027-09-17",
          "status": "Building 1 operational. Based on the completion date to \"build-out an office and data hall\", stated in a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008308).",
          "buildingsOperational": 1.0,
          "itPowerMw": 336.0,
          "h100Equivalent": 853966.649823143,
          "capitalCostB": 12.728352000000001
        },
        {
          "date": "2027-11-11",
          "status": "Building 2 operational. Based on the completion date to \"build-out an office and data hall\", stated in a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008308).",
          "buildingsOperational": 2.0,
          "itPowerMw": 672.0,
          "h100Equivalent": 1707933.299646286,
          "capitalCostB": 25.456704000000002
        }
      ]
    },
    {
      "name": "Goodnight",
      "slug": "goodnight",
      "owner": "Google",
      "ownerConfidence": "speculative",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "10001 Lima Rd, Claude, TX 79019",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [
        "B300",
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-05-19",
          "status": "Land clearing begins",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-16",
          "status": "Building 1 and 2 under construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-23",
          "status": "Construction on Building 1 and 2 looks about halfway to completion. Foundations and utility trenches are visible for Building 3-4. Building 5-6 have an outline. The substation appears to be expanding.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-16",
          "status": "Progress is made on all buildings, Building 1 and 2 specically have begun to install cooling structures. The substation expansion seems to be nearing completion.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-15",
          "status": "Building 1 operational. This [regulatory document](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025027064) lists the completion date for Building 1 as 2026-09-12, the current status suggests this estimate will not be met. From the timeline seen at the Abilene, Texas site for the same building styles we estimate operability to occur 8 months after the state seen in April 2026.",
          "buildingsOperational": 1.0,
          "itPowerMw": 103.0,
          "h100Equivalent": 124305.20464881253,
          "capitalCostB": 3.901846
        },
        {
          "date": "2027-02-15",
          "status": "Building 2 operational. The completion date for [Building 2 Tenant Improvement](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025027065) is 2026-11-07, about 2 months later than Building 1. We therefore add 2 months to the Building 1 operational date.",
          "buildingsOperational": 2.0,
          "itPowerMw": 206.0,
          "h100Equivalent": 249115.7150075796,
          "capitalCostB": 7.803692
        },
        {
          "date": "2027-10-01",
          "status": "6 buildings are operational. This is based on: 1. A [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026010861) for Building 6 with a completion date of 2027-07-30. Normally there is a follow-up filing for \"tenant improvement\" which involves building the interior, with a completion date 1-3 months after the initial filing. 2. A project deadline of EOY 2027 in the [original tax abatement agreement](https://www.co.armstrong.tx.us/upload/page/5361/Phase%201%20Tax%20Abatement%20Agreement%20-%20Signed.pdf) 3. The similar 8-building project in Abilene taking an estimated 2 years and 2 months.",
          "buildingsOperational": 6.0,
          "itPowerMw": 1006.0,
          "h100Equivalent": 2278928.7518948964,
          "capitalCostB": 38.109291999999996
        }
      ]
    },
    {
      "name": "Google Cedar Rapids",
      "slug": "google-cedar-rapids",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "5800 EDGEWOOD RD SW CEDAR RAPIDS, IA 52404",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2024-05-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-27",
          "status": "Building 1 cooling towers and generators starting to be put in place. There's a foundation for Building 2 and 3.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-12-29",
          "status": "About half of Building 1 generators are in place. Building 2 roofing has started - about where Google Omaha Building 3 was on 2025-03-16.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-16",
          "status": "Building 1's generators are still only about halfway in place, and ~1/2 the cooling towers are still under construction. Building 2 roofing has been completed, and visible foundations have been built for cooling towers and generators.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-31",
          "status": "Building 1 is operational. There is still work to be done since April, and Q4 2026 operational estimate was based on visible progress then.",
          "buildingsOperational": 1.0,
          "itPowerMw": 87.0,
          "h100Equivalent": 234765.03284487114,
          "capitalCostB": 3.2957339999999995
        },
        {
          "date": "2027-02-22",
          "status": "Building 2 is operational. Based on Google Omaha Building 3 taking about 14 months from starting the roof to operation.",
          "buildingsOperational": 2.0,
          "itPowerMw": 174.0,
          "h100Equivalent": 505073.2693279434,
          "capitalCostB": 6.591467999999999
        },
        {
          "date": "2027-05-23",
          "status": "Building 3 is operational. Earlier satellite images suggest it was about 3 months behind Building 2.",
          "buildingsOperational": 3.0,
          "itPowerMw": 261.0,
          "h100Equivalent": 816321.3744315312,
          "capitalCostB": 9.887202
        }
      ]
    },
    {
      "name": "Google Fort Wayne",
      "slug": "google-fort-wayne",
      "owner": "Google",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Google DeepMind",
          "confidence": "speculative"
        }
      ],
      "country": "United States",
      "address": "6015 Adams Center Road, Fort Wayne, IN 46806",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2024-04-01",
          "status": "First signs of development/land clearing",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2024-09-13",
          "status": "Roof complete on Building 1 (the 'H'), although we suspect this building is not for AI compute due to the construction speed, irregular design, and lack of external cooling.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-06-10",
          "status": "After a long quiet period they've laid foundations for Building 2 and the substation.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-01",
          "status": "Building 2 looks externally complete",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-01",
          "status": "The chillers for Buildings 2 and 3 are both a little less than half done and the buildings still look like active construction sites.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-01",
          "status": "Estimated operational date of Building 2, the first AI compute building. However, this represents less than 1/5 of the estimated total compute being available because chips installed in the future will be more power-efficient.",
          "buildingsOperational": 1.0,
          "itPowerMw": 173.0,
          "h100Equivalent": 464881.25315816066,
          "capitalCostB": 6.553585999999999
        },
        {
          "date": "2028-04-01",
          "status": "Estimated completion time for all 5 main AI buildings assuming construction continues at the same rate, based on the observed timelines of Buildings 2 and 3.",
          "buildingsOperational": 5.0,
          "itPowerMw": 863.0,
          "h100Equivalent": 4704396.159676605,
          "capitalCostB": 32.692166
        }
      ]
    },
    {
      "name": "Meta Hyperion",
      "slug": "meta-hyperion",
      "owner": "Meta",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "Meta",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "Holly Ridge, LA 71269",
      "project": "Hyperion #confident",
      "currentChipTypes": [],
      "allChipTypes": [
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2024-12-20",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-19",
          "status": "Foundations are underway for the main buildings, and the overall layout aligns with the [architectural renderings](https://engineering.fb.com/2025/09/29/data-infrastructure/metas-infrastructure-evolution-and-the-advent-of-ai/) published in 2025.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-19",
          "status": "Building 1 and 2 roof is finished and cooling is at an advanced stage of installation. Building 3 and 6 roof and cooling in progress.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-01",
          "status": "New [power stations](https://drive.google.com/file/d/1D4eUHwEuirNi0g3IU_xGOti3PcC8fcXi/view?usp=sharing) are in service for a 1.8 GW load at Holly Ridge. However, the data center is still not operational.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2028-01-01",
          "status": "First phase is operational, based on a [Meta blog post](https://drive.google.com/file/d/1PmFNgOwkPepwjpGIbNUuPJP0LNgIqe7l/view?usp=sharing). We assume that this aligns with the three natural gas turbines being completed, for a total of 2262 MW capacity, but that these turbines have a backup role. This is close to the 1800 MW of load requested from the grid. Meta [claims](https://engineering.fb.com/2025/09/29/data-infrastructure/metas-infrastructure-evolution-and-the-advent-of-ai/) that \"The Hyperion cluster will have a 5-gigawatt capacity once complete\", but so far there is no concrete evidence for this happening at the Holly Ridge site alone.",
          "buildingsOperational": 9.0,
          "itPowerMw": 1676.0,
          "h100Equivalent": 4253594.239514907,
          "capitalCostB": 63.49023199999999
        }
      ]
    },
    {
      "name": "OpenAI Stargate Lordstown",
      "slug": "openai-stargate-lordstown",
      "owner": "Softbank",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "2300 Hallock Young Rd, Warren, OH 44481",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-10-12",
          "status": "Land clearing begins in the front of the site (the side facing the Ohio Turnpike), clearing away a parking lot and solar array",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-27",
          "status": "Still no visible construction, although construction within preexisting facilities",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        }
      ]
    },
    {
      "name": "OpenAI Stargate Michigan",
      "slug": "openai-stargate-michigan",
      "owner": "Oracle",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-12-04",
          "status": "Land clearing begins for the entire site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-20",
          "status": "Land clearing continues for all buildings (1-3)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-12",
          "status": "Groundwork is visible for Building 1, at the left end of the site.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2028-12-31",
          "status": "Buildings 1-3 operational. Based on when maximum power load will be provided by DTE energy (Dec 2027), which can be extended by a year. [Source, page 3](https://mi-psc.my.site.com/sfc/servlet.shepherd/version/download/068cs00001MH71XAAT)",
          "buildingsOperational": 3.0,
          "itPowerMw": 988.0,
          "h100Equivalent": 2880242.5467407783,
          "capitalCostB": 37.427416
        }
      ]
    },
    {
      "name": "OpenAI Stargate Milam",
      "slug": "openai-stargate-milam",
      "owner": "Softbank",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-09-27",
          "status": "Land clearing begins for the site",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-04",
          "status": "Small sections of building foundation construction begins, and land clearing appears to be mostly finished",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-03-23",
          "status": "Steel framing and roofing is underway for Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2028-12-31",
          "status": "All buildings finished, site is fully operational. Our reasoning is that examples so far take a median of 2-2.5 years to go from land clearing to 1 GW. This suggests around 2028-01-01 here. However, due to delays being more likely than speedups and the fact that this base rate data is still unproven, the more conservative estimate is made. The current state of the site also supports this estimation.",
          "buildingsOperational": null,
          "itPowerMw": 857.0,
          "h100Equivalent": 2496210.207175341,
          "capitalCostB": 32.464873999999995
        }
      ]
    },
    {
      "name": "OpenAI Stargate New Mexico",
      "slug": "openai-stargate-new-mexico",
      "owner": "Oracle",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-10-01",
          "status": "Construction and land clearing begins",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-06",
          "status": "Land clearing continues, foundation construction begins 2 of the main buildings (Building B & D). Construction also beginning on modular chiller plants.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-06-22",
          "status": "Construction has advanced significantly since February 2026. We observe extensive earthworks and multiple graded building pads across the campus, with structural work underway on the main data center buildings. A large solar array and water storage basins are visible on site, and two cleared areas on the western side of the campus, likely for on-site power generation. No buildings appear operational yet (no completed roofs or signs of active cooling), consistent with the projected 2028 completion.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2028-12-31",
          "status": "Estimated construction completion date of the site. Stormwater permitting says 2027-12-31 for stormwater construction to finish, but for a more conservative estimate and based on the current state of the site, we pushed the final date by a year beyond it. [Source, page 2](https://drive.google.com/file/d/1vVKvPogq2TkeFn7ibnp0GNqz8aB4tZXz/view?usp=sharing)",
          "buildingsOperational": 4.0,
          "itPowerMw": 1750.0,
          "h100Equivalent": 5103587.670540676,
          "capitalCostB": 66.2935
        }
      ]
    },
    {
      "name": "OpenAI Stargate Shackelford",
      "slug": "openai-stargate-shackelford",
      "owner": "Oracle",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "175 Private Road 1604, Abilene, TX 79601, Shackelford County",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-08-01",
          "status": "Land clearing begins.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-01-18",
          "status": "The layout of Buildings 1-5 is visible. Steel framing has just started on Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-14",
          "status": "Steel framing is underway for Buildings 1-3, and roofing is underway for Building 1.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2027-08-15",
          "status": "Building 1 is operational (estimate). TDLR lists the construction completion date for Building 1 as 2027-02-15. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 1.0,
          "itPowerMw": 140.0,
          "h100Equivalent": 355229.9140980293,
          "capitalCostB": 5.30348
        },
        {
          "date": "2027-10-19",
          "status": "Building 2 is operational (estimate). TDLR lists the construction completion date for Building 2 as 2027-04-19. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 2.0,
          "itPowerMw": 280.0,
          "h100Equivalent": 712481.0510358767,
          "capitalCostB": 10.60696
        },
        {
          "date": "2027-11-18",
          "status": "Building 3 is operational (estimate). TDLR lists the construction completion date for Building 3 as 2027-05-18. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 3.0,
          "itPowerMw": 420.0,
          "h100Equivalent": 1066195.0480040424,
          "capitalCostB": 15.910439999999998
        },
        {
          "date": "2028-02-11",
          "status": "Building 4 is operational (estimate). TDLR lists the construction completion date for Building 4 as 2027-08-11. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 4.0,
          "itPowerMw": 560.0,
          "h100Equivalent": 1419909.044972208,
          "capitalCostB": 21.21392
        },
        {
          "date": "2028-03-08",
          "status": "Building 5 is operational (estimate). TDLR lists the construction completion date for Building 5 as 2027-09-08. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 5.0,
          "itPowerMw": 700.0,
          "h100Equivalent": 1778676.0990399192,
          "capitalCostB": 26.5174
        },
        {
          "date": "2028-04-04",
          "status": "Building 6 is operational (estimate). TDLR lists the construction completion date for Building 6 as 2027-10-04. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 6.0,
          "itPowerMw": 840.0,
          "h100Equivalent": 2334512.379989894,
          "capitalCostB": 31.820879999999995
        },
        {
          "date": "2028-05-12",
          "status": "Building 7 is operational (estimate). TDLR lists the construction completion date for Building 7 as 2027-11-12. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 7.0,
          "itPowerMw": 980.0,
          "h100Equivalent": 2890348.6609398685,
          "capitalCostB": 37.124359999999996
        },
        {
          "date": "2028-10-17",
          "status": "Building 8 is operational (estimate). TDLR lists the construction completion date for Building 8 as 2028-04-17. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 8.0,
          "itPowerMw": 1120.0,
          "h100Equivalent": 3451237.998989389,
          "capitalCostB": 42.42784
        },
        {
          "date": "2028-10-18",
          "status": "Building 9 is operational (estimate). TDLR lists the construction completion date for Building 9 as 2028-04-18. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 9.0,
          "itPowerMw": 1260.0,
          "h100Equivalent": 4007074.2799393632,
          "capitalCostB": 47.731320000000004
        },
        {
          "date": "2028-11-11",
          "status": "Building 10 is operational (estimate). TDLR lists the construction completion date for Building 10 as 2028-05-11. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
          "buildingsOperational": 10.0,
          "itPowerMw": 1400.0,
          "h100Equivalent": 4562910.560889338,
          "capitalCostB": 53.0348
        }
      ]
    },
    {
      "name": "OpenAI Stargate UAE",
      "slug": "openai-stargate-uae",
      "owner": "G42",
      "ownerConfidence": "likely",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United Arab Emirates",
      "address": "Nexus L&T Project Office, Al Bihouth, Al Dhafrah, Abu Dhabi, United Arab Emirates",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [
        "B300",
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-06-09",
          "status": "Land clearing begins for Building 1 and 2",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-11-16",
          "status": "Building 1 and 2 are partly constructed. No clear evidence of more buildings starting construction.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-12-01",
          "status": "Building 1 and 2 are operational. The similar data center in Ajman, UAE was delayed by over a year, now due in December 2026 (compare [1](https://khaznadatacenters.com/press-release/khazna-expands-infrastructure-to-accelerate-uaes-leadership-in-artificial-intelligence/), [2](https://khaznadatacenters.com/press-release/khazna-announces-the-uaes-first-ai-optimized-data-center-and-the-largest-in-its-portfolio-powering-the-nations-drive-toward-ai-leadership/)). The buildings here looked 3-6 months behind the Ajman building as of November 2025, but they were moving faster. So we think Building 1 and 2 are on track for 200 MW by December 2026, along with the Ajman building.",
          "buildingsOperational": 2.0,
          "itPowerMw": 200.0,
          "h100Equivalent": 252652.85497726125,
          "capitalCostB": 7.5764
        },
        {
          "date": "2028-01-01",
          "status": "1 GW of IT power is operational. We haven’t seen expansion beyond 200 MW as of November 2025. Optimistically, 8 more 100 MW buildings start construction in December 2025, in parallel, and take 1.5 years like the first two buildings, hitting 1 GW by Q3 2027. More realistically, there's some staggering of construction over several months, like Stargate Abilene. Our median estimate is January 2028.",
          "buildingsOperational": 10.0,
          "itPowerMw": 1000.0,
          "h100Equivalent": 2021222.83981809,
          "capitalCostB": 37.882
        }
      ]
    },
    {
      "name": "OpenAI Stargate Wisconsin",
      "slug": "openai-stargate-wisconsin",
      "owner": "Oracle",
      "ownerConfidence": "confident",
      "users": [
        {
          "name": "OpenAI",
          "confidence": "confident"
        }
      ],
      "country": "United States",
      "address": "",
      "project": "Stargate #confident",
      "currentChipTypes": [],
      "allChipTypes": [],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2026-01-02",
          "status": "Ground broken for the facility, land clearing begins for all buildings",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-02-14",
          "status": "Land clearing continues, foundation construction clearly begins for eastern and northern buildings (Building 1-2)",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2028-12-31",
          "status": "Building 4 and supporting facilities/buildings operational, whole facility now operational. Based on the [environmental analysis (page 6)](https://drive.google.com/file/d/1ft2ZzqAYZtsTqMwyML4eo_EFYuclVxE6/view?usp=sharing) filed for the site.",
          "buildingsOperational": 4.0,
          "itPowerMw": 902.0,
          "h100Equivalent": 2627589.691763517,
          "capitalCostB": 34.169564
        }
      ]
    },
    {
      "name": "QTS Cedar Rapids",
      "slug": "qts-cedar-rapids",
      "owner": "Unknown",
      "ownerConfidence": "unknown",
      "users": [],
      "country": "United States",
      "address": "6200 76th Ave SW, Fairfax, IA 52228",
      "project": "",
      "currentChipTypes": [],
      "allChipTypes": [
        "Rubin"
      ],
      "currentPowerMw": 0,
      "currentH100Equivalent": 0,
      "currentCapitalCostB": 0,
      "timeline": [
        {
          "date": "2025-01-17",
          "status": "Land clearing begins for Building 1-3.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2025-10-27",
          "status": "Building 1 roof complete, with air-cooled chillers in place. Building 2 and 3 roofs are partly completed. Building 4 and 5 have a foundation.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-04-16",
          "status": "Based on satellite imagery, the Buildings 1-3 shells look complete. Buildings 4-6 are far along, with roofs largely in place, while the eastern Building 7 foundation is well underway. No buildings operational yet.",
          "buildingsOperational": null,
          "itPowerMw": null,
          "h100Equivalent": null,
          "capitalCostB": null
        },
        {
          "date": "2026-05-07",
          "status": "Similar to April, Buildings 1-3 shells look complete. Buildings 4-6 are still far along, and the eastern Building 7 foundation is still underway.",
          "buildingsOperational": 0.0,
          "itPowerMw": 0.0,
          "h100Equivalent": 0.0,
          "capitalCostB": 0.0
        },
        {
          "date": "2026-11-15",
          "status": "Buildings 1-3 are operational. Based on the expected completion date reported by [local news](https://corridorbusiness.com/scope-of-qts-data-project-in-cedar-rapids-continuing-to-grow/): “A QTS spokesperson said in July [2025] that the first phase of the project was expected to be completed in late 2026.\"",
          "buildingsOperational": 3.0,
          "itPowerMw": 448.0,
          "h100Equivalent": 1136975.5639961243,
          "capitalCostB": 16.971136
        },
        {
          "date": "2027-11-15",
          "status": "Buildings 4-7 are operational. Based on the expected completion date reported by [local news](https://corridorbusiness.com/scope-of-qts-data-project-in-cedar-rapids-continuing-to-grow/): “A QTS spokesperson said in July [2025] that [...] The second phase is expected to be completed in late 2027.\"",
          "buildingsOperational": 7.0,
          "itPowerMw": 1133.0,
          "h100Equivalent": 3668823.12124194,
          "capitalCostB": 42.920306
        }
      ]
    }
  ]
};

export default epochDataCenterProjects;
